// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  acceptPrivacyPolicy,
  acceptTerms,
  addTeamMember,
  applyForJob,
  applyPlannerSession,
  applyPlanOperation,
  archiveJob,
  bookingUnsubscribe,
  bookingWithdraw,
  bookSlot,
  bulkAssessmentIntake,
  bulkInterviewIntake,
  bulkScreeningIntake,
  checkAlreadyInSystem,
  checkSimulationAssertions,
  completeCodingAssessment,
  completeCopilotGuideItem,
  completePrescreenConversation,
  createApplicationQuestion,
  createCodingAssessmentRecordingSession,
  createCopilotRound,
  createInterviewPlan,
  createJob,
  createPartnerCredential,
  createScreenerPlan,
  createTenant,
  decidePlannerSession,
  deleteApplicationCandidate,
  deleteApplicationQuestion,
  deleteDocument,
  editPlannerSession,
  evaluateScreenerApplication,
  evaluateScreenerJob,
  executeTaskTasksExecutePost,
  expandJobDescription,
  exportApplications,
  exportBoard,
  exportScreenerPlans,
  forceReleasePrescreenConversation,
  generateInkeepToken,
  generateInteractiveProblem,
  generateInterviewPlanRubric,
  generateInterviewShareToken,
  generateScreenerShareToken,
  generateSectionCriteria,
  generateSimulationPersona,
  getActiveEmailTemplate,
  getApplication,
  getApplicationCopilotRound,
  getApplicationQuestions,
  getAssessmentApplications,
  getAssessmentAttempt,
  getAssessmentAttemptRecordingUrl,
  getAssessmentConfig,
  getAssessmentRecordingUrl,
  getBoardExportOptions,
  getBoardRow,
  getBoardSummary,
  getBookingConfig,
  getBookingIcs,
  getBookingSlots,
  getBookingStatus,
  getCachedSections,
  getCandidateIntakeValidationStatus,
  getCandidateInterview,
  getCodingAssessmentExecutionStatus,
  getCodingAssessmentPreview,
  getCodingAssessmentProblemAsset,
  getConsumptionReport,
  getCopilotFeedback,
  getCopilotRound,
  getCopilotTranscript,
  getCurrentTenant,
  getCurrentTenantPublic,
  getCurrentUser,
  getDocumentContent,
  getDocumentDownloadUrl,
  getEmailTemplate,
  getEmailTemplateVariables,
  getExportOptions,
  getGreenhouseMetadata,
  getInterviewingCounts,
  getInterviewPlan,
  getInterviewPlanDraft,
  getInterviewPlanRubric,
  getInterviewResult,
  getJob,
  getJobAnalytics,
  getJobAnalyticsBatches,
  getJobAnalyticsExcel,
  getJobApplicationQuestions,
  getJobLoginContext,
  getListingFilterOptions,
  getMyCopilotRound,
  getMyJob,
  getMyPermissions,
  getPartnerCredential,
  getPartnerCredentialByKeyId,
  getPlannerSession,
  getPlannerTurns,
  getPrescreenConversation,
  getPrescreenConversationDetail,
  getPrescreenConversations,
  getProblemBankAsset,
  getProblemTopics,
  getProctoringClipUrl,
  getPublicJob,
  getPublicScreenerApplication,
  getRecruiterInterview,
  getScreenerPlan,
  getScreeningApplication,
  getScreeningApplications,
  getSectionTimeLimits,
  getSharedAssessmentRecordingUrl,
  getSharedAssessmentResult,
  getSimulation,
  getSimulationPersona,
  getSimulationTranscript,
  getTenantById,
  getUsageAnalytics,
  getWorkflowAuditHistory,
  getWorkflowAvailableEvents,
  getWorkflowBulkAvailableEvents,
  globalCandidateSearch,
  greenhouseListTests,
  greenhouseRequestErrors,
  greenhouseSendTest,
  greenhouseTestStatus,
  inviteTenantMember,
  inviteToAssessment,
  inviteToInterview,
  listApplications,
  listBoard,
  listCodingAssessmentSubmissions,
  listCopilotRounds,
  listDocuments,
  listEmailTemplates,
  listInterviewingApplications,
  listInterviewPlans,
  listInterviewsForJob,
  listJobs,
  listMyCopilotRounds,
  listMyInterviews,
  listMyJobs,
  listPendingBookingInvites,
  listPublicJobs,
  listSimulationPersonas,
  listSimulations,
  listTeamMembers,
  listTenantMembers,
  listTenantRoles,
  listTenants,
  markCodingAssessmentEditorLoaded,
  markCopilotRoundNoShow,
  migratePlannerSession,
  type Options,
  parseCandidateResume,
  previewSampleProblems,
  pronounceWithTenantVoice,
  publishJob,
  questionGeneratorLlm,
  recheckSimulation,
  recordCodingAssessmentEvents,
  recordConnectionQuality,
  recordGreenhouseMetadata,
  recordProctoringFeedback,
  refineCopilotGuide,
  refineJdSelection,
  refineJobDescription,
  refreshSentEmails,
  regenerateCaseStudy,
  regenerateCopilotGuide,
  removeTeamMember,
  removeTenantMember,
  requestReschedule,
  rescheduleCopilotRound,
  resolveSimulationPersona,
  restoreDeclined,
  resumePlannerSession,
  reviewReschedule,
  revokePartnerCredential,
  revokePartnerCredentialByKeyId,
  runCodingAssessmentCode,
  saveAssessmentConfig,
  saveAssessmentRequirements,
  saveCopilotFeedback,
  saveInterviewPlanDraft,
  scheduleCopilotRound,
  searchSentEmails,
  sendBookingInvites,
  sendCaseStudyChatMessage,
  sendCopilotRoundInvites,
  sendTestEmail,
  setIntakeMetadata,
  setSelectionStatus,
  singleAssessmentIntake,
  singleCopilotIntake,
  singleInterviewIntake,
  singleScreeningIntake,
  startCandidateIntakeValidation,
  startCodingAssessment,
  startCopilotListening,
  startJobDesignGeneration,
  startJobSetupGeneration,
  startPlannerSession,
  startPrescreenConversation,
  startSimulation,
  stopCopilotListening,
  submitApplicationAnswers,
  submitCodingAssessmentCode,
  suggestAssessmentDesign,
  suggestCopilotQuestions,
  suggestCopilotStart,
  suggestInteractiveConfig,
  suggestQuestions,
  suggestSubtopics,
  suggestTopics,
  syncCodingAssessmentDraft,
  unpublishJob,
  updateApplicationQuestion,
  updateAssessmentAiProctoring,
  updateAssessmentInstructions,
  updateAssessmentLiveProctoring,
  updateCopilotGuide,
  updateCurrentTenant,
  updateCurrentUser,
  updateCustomInstructions,
  updateEmailTemplate,
  updateInterviewPlanRubric,
  updateJob,
  updateJobSetupState,
  updateLiveProctoring,
  updateOfflineProctoring,
  updatePartnerCredentialWebhook,
  updatePartnerCredentialWebhookByKeyId,
  updateScreenerPlan,
  updateTeamMemberRole,
  updateTenantMemberRole,
  uploadJobDescription,
  uploadReferenceDocument,
  uploadResumeForApplication,
  upsertApplication,
  upsertBookingConfig,
  v2HealthHealthGet,
  workflowAssignReviewer,
  workflowBulkAssignByAddedBy,
  workflowBulkAssignReviewer,
  workflowBulkChangeAssessmentDeadline,
  workflowBulkChangeDeadline,
  workflowBulkRejectBelow,
  workflowBulkSendReminder,
  workflowBulkTransition,
  workflowRejectBelowPreview,
  workflowReminderPreview,
  workflowSubmitHumanReview,
  workflowTransition,
} from '../sdk.gen';
import type {
  AcceptPrivacyPolicyData,
  AcceptPrivacyPolicyResponse,
  AcceptTermsData,
  AcceptTermsResponse,
  AddTeamMemberData,
  AddTeamMemberResult,
  ApplyForJobData,
  ApplyForJobResult,
  ApplyPlannerSessionData,
  ApplyPlannerSessionResult,
  ApplyPlanOperationData,
  ApplyPlanOperationResult,
  ArchiveJobData,
  ArchiveJobResponse,
  BookingUnsubscribeData,
  BookingUnsubscribeResponse,
  BookingWithdrawData,
  BookingWithdrawResponse,
  BookSlotData,
  BookSlotResponse,
  BulkAssessmentIntakeData,
  BulkAssessmentIntakeResult,
  BulkInterviewIntakeData,
  BulkInterviewIntakeResult,
  BulkScreeningIntakeData,
  BulkScreeningIntakeResult,
  CheckAlreadyInSystemData,
  CheckAlreadyInSystemResult,
  CheckSimulationAssertionsData,
  CheckSimulationAssertionsError,
  CheckSimulationAssertionsResponse,
  CompleteCodingAssessmentData,
  CompleteCodingAssessmentResponse,
  CompleteCopilotGuideItemData,
  CompleteCopilotGuideItemResponse,
  CompletePrescreenConversationData,
  CompletePrescreenConversationResponse,
  CreateApplicationQuestionData,
  CreateApplicationQuestionResponse,
  CreateCodingAssessmentRecordingSessionData,
  CreateCodingAssessmentRecordingSessionResponse,
  CreateCopilotRoundData,
  CreateCopilotRoundResponse,
  CreateInterviewPlanData,
  CreateInterviewPlanResponse,
  CreateJobData,
  CreateJobResponse,
  CreatePartnerCredentialData,
  CreatePartnerCredentialResult,
  CreateScreenerPlanData,
  CreateScreenerPlanResponse,
  CreateTenantData,
  CreateTenantResponse,
  DecidePlannerSessionData,
  DecidePlannerSessionResponse,
  DeleteApplicationCandidateData,
  DeleteApplicationCandidateResponse,
  DeleteApplicationQuestionData,
  DeleteApplicationQuestionResult,
  DeleteDocumentData,
  DeleteDocumentResponse,
  EditPlannerSessionData,
  EditPlannerSessionResponse,
  EvaluateScreenerApplicationData,
  EvaluateScreenerApplicationResponse,
  EvaluateScreenerJobData,
  EvaluateScreenerJobResponse,
  ExecuteTaskTasksExecutePostData,
  ExecuteTaskTasksExecutePostError,
  ExecuteTaskTasksExecutePostResponse,
  ExpandJobDescriptionData,
  ExpandJobDescriptionResponse,
  ExportApplicationsData,
  ExportBoardData,
  ExportScreenerPlansData,
  ExportScreenerPlansResponse,
  ForceReleasePrescreenConversationData,
  ForceReleasePrescreenConversationResponse,
  GenerateInkeepTokenData,
  GenerateInkeepTokenResponse,
  GenerateInteractiveProblemData,
  GenerateInteractiveProblemResponse,
  GenerateInterviewPlanRubricData,
  GenerateInterviewPlanRubricResponse,
  GenerateInterviewShareTokenData,
  GenerateInterviewShareTokenResponse,
  GenerateScreenerShareTokenData,
  GenerateScreenerShareTokenResponse,
  GenerateSectionCriteriaData,
  GenerateSectionCriteriaResponse,
  GenerateSimulationPersonaData,
  GenerateSimulationPersonaError,
  GenerateSimulationPersonaResponse,
  GetActiveEmailTemplateData,
  GetActiveEmailTemplateResponse,
  GetApplicationCopilotRoundData,
  GetApplicationCopilotRoundResponse,
  GetApplicationData,
  GetApplicationQuestionsData,
  GetApplicationQuestionsResponse,
  GetApplicationResponse,
  GetAssessmentApplicationsData,
  GetAssessmentApplicationsResponse,
  GetAssessmentAttemptData,
  GetAssessmentAttemptRecordingUrlData,
  GetAssessmentAttemptRecordingUrlResponse,
  GetAssessmentAttemptResponse,
  GetAssessmentConfigData,
  GetAssessmentConfigResult,
  GetAssessmentRecordingUrlData,
  GetAssessmentRecordingUrlResponse,
  GetBoardExportOptionsData,
  GetBoardExportOptionsResponse,
  GetBoardRowData,
  GetBoardRowResponse,
  GetBoardSummaryData,
  GetBoardSummaryResponse,
  GetBookingConfigData,
  GetBookingConfigResponse,
  GetBookingIcsData,
  GetBookingSlotsData,
  GetBookingSlotsResponse,
  GetBookingStatusData,
  GetBookingStatusResponse,
  GetCachedSectionsData,
  GetCachedSectionsResponse,
  GetCandidateIntakeValidationStatusData,
  GetCandidateIntakeValidationStatusResponse,
  GetCandidateInterviewData,
  GetCandidateInterviewResponse,
  GetCodingAssessmentExecutionStatusData,
  GetCodingAssessmentExecutionStatusResponse,
  GetCodingAssessmentPreviewData,
  GetCodingAssessmentPreviewResponse,
  GetCodingAssessmentProblemAssetData,
  GetConsumptionReportData,
  GetCopilotFeedbackData,
  GetCopilotFeedbackResponse,
  GetCopilotRoundData,
  GetCopilotRoundResponse,
  GetCopilotTranscriptData,
  GetCopilotTranscriptResponse,
  GetCurrentTenantData,
  GetCurrentTenantPublicData,
  GetCurrentTenantPublicResponse,
  GetCurrentTenantResponse,
  GetCurrentUserData,
  GetCurrentUserResponse,
  GetDocumentContentData,
  GetDocumentContentResponse,
  GetDocumentDownloadUrlData,
  GetDocumentDownloadUrlResponse,
  GetEmailTemplateData,
  GetEmailTemplateResponse,
  GetEmailTemplateVariablesData,
  GetEmailTemplateVariablesResponse,
  GetExportOptionsData,
  GetExportOptionsResponse,
  GetGreenhouseMetadataData,
  GetGreenhouseMetadataResponse,
  GetInterviewingCountsData,
  GetInterviewingCountsResponse,
  GetInterviewPlanData,
  GetInterviewPlanDraftData,
  GetInterviewPlanDraftResponse,
  GetInterviewPlanResponse,
  GetInterviewPlanRubricData,
  GetInterviewPlanRubricResponse,
  GetInterviewResultData,
  GetInterviewResultResponse,
  GetJobAnalyticsBatchesData,
  GetJobAnalyticsBatchesResponse,
  GetJobAnalyticsData,
  GetJobAnalyticsExcelData,
  GetJobAnalyticsResponse,
  GetJobApplicationQuestionsData,
  GetJobApplicationQuestionsResponse,
  GetJobData,
  GetJobLoginContextData,
  GetJobLoginContextResponse,
  GetJobResponse,
  GetListingFilterOptionsData,
  GetListingFilterOptionsResponse,
  GetMyCopilotRoundData,
  GetMyCopilotRoundResponse,
  GetMyJobData,
  GetMyJobResponse,
  GetMyPermissionsData,
  GetMyPermissionsResponse,
  GetPartnerCredentialByKeyIdData,
  GetPartnerCredentialByKeyIdResponse,
  GetPartnerCredentialData,
  GetPartnerCredentialResponse,
  GetPlannerSessionData,
  GetPlannerSessionResponse,
  GetPlannerTurnsData,
  GetPlannerTurnsResponse,
  GetPrescreenConversationData,
  GetPrescreenConversationDetailData,
  GetPrescreenConversationDetailResponse,
  GetPrescreenConversationResponse,
  GetPrescreenConversationsData,
  GetPrescreenConversationsResponse,
  GetProblemBankAssetData,
  GetProblemTopicsData,
  GetProblemTopicsResponse,
  GetProctoringClipUrlData,
  GetProctoringClipUrlResponse,
  GetPublicJobData,
  GetPublicJobResponse,
  GetPublicScreenerApplicationData,
  GetPublicScreenerApplicationResponse,
  GetRecruiterInterviewData,
  GetRecruiterInterviewResponse,
  GetScreenerPlanData,
  GetScreenerPlanResponse,
  GetScreeningApplicationData,
  GetScreeningApplicationResponse,
  GetScreeningApplicationsData,
  GetScreeningApplicationsResponse,
  GetSectionTimeLimitsData,
  GetSectionTimeLimitsResponse,
  GetSharedAssessmentRecordingUrlData,
  GetSharedAssessmentRecordingUrlResponse,
  GetSharedAssessmentResultData,
  GetSharedAssessmentResultResponse,
  GetSimulationData,
  GetSimulationError,
  GetSimulationPersonaData,
  GetSimulationPersonaError,
  GetSimulationPersonaResponse,
  GetSimulationResponse,
  GetSimulationTranscriptData,
  GetSimulationTranscriptError,
  GetSimulationTranscriptResponse,
  GetTenantByIdData,
  GetTenantByIdResponse,
  GetUsageAnalyticsData,
  GetUsageAnalyticsResponse,
  GetWorkflowAuditHistoryData,
  GetWorkflowAuditHistoryResponse,
  GetWorkflowAvailableEventsData,
  GetWorkflowAvailableEventsResponse,
  GetWorkflowBulkAvailableEventsData,
  GetWorkflowBulkAvailableEventsResponse,
  GlobalCandidateSearchData,
  GlobalCandidateSearchResponse,
  GreenhouseListTestsData,
  GreenhouseListTestsResponse,
  GreenhouseRequestErrorsData,
  GreenhouseRequestErrorsResponse,
  GreenhouseSendTestData,
  GreenhouseSendTestResponse,
  GreenhouseTestStatusData,
  GreenhouseTestStatusResponse,
  InviteTenantMemberData,
  InviteTenantMemberResult,
  InviteToAssessmentData,
  InviteToAssessmentResult,
  InviteToInterviewData,
  InviteToInterviewResult,
  ListApplicationsData,
  ListApplicationsResult,
  ListBoardData,
  ListBoardResponse,
  ListCodingAssessmentSubmissionsData,
  ListCodingAssessmentSubmissionsResponse,
  ListCopilotRoundsData,
  ListCopilotRoundsResult,
  ListDocumentsData,
  ListDocumentsResult,
  ListEmailTemplatesData,
  ListEmailTemplatesResult,
  ListInterviewingApplicationsData,
  ListInterviewingApplicationsResult,
  ListInterviewPlansData,
  ListInterviewPlansResult,
  ListInterviewsForJobData,
  ListInterviewsForJobResponse,
  ListJobsData,
  ListJobsResult,
  ListMyCopilotRoundsData,
  ListMyCopilotRoundsResponse,
  ListMyInterviewsData,
  ListMyInterviewsResult,
  ListMyJobsData,
  ListMyJobsResult,
  ListPendingBookingInvitesData,
  ListPendingBookingInvitesResult,
  ListPublicJobsData,
  ListPublicJobsResult,
  ListSimulationPersonasData,
  ListSimulationPersonasResponse,
  ListSimulationsData,
  ListSimulationsError,
  ListSimulationsResult,
  ListTeamMembersData,
  ListTeamMembersResult,
  ListTenantMembersData,
  ListTenantMembersResult,
  ListTenantRolesData,
  ListTenantRolesResponse,
  ListTenantsData,
  ListTenantsResult,
  MarkCodingAssessmentEditorLoadedData,
  MarkCodingAssessmentEditorLoadedResponse,
  MarkCopilotRoundNoShowData,
  MarkCopilotRoundNoShowResponse,
  MigratePlannerSessionData,
  MigratePlannerSessionResponse,
  ParseCandidateResumeData,
  ParseCandidateResumeResponse,
  PreviewSampleProblemsData,
  PreviewSampleProblemsResult,
  PronounceWithTenantVoiceData,
  PronounceWithTenantVoiceResponse,
  PublishJobData,
  PublishJobResponse,
  QuestionGeneratorLlmData,
  QuestionGeneratorLlmResponse,
  RecheckSimulationData,
  RecheckSimulationError,
  RecheckSimulationResult,
  RecordCodingAssessmentEventsData,
  RecordCodingAssessmentEventsResponse,
  RecordConnectionQualityData,
  RecordConnectionQualityResult,
  RecordGreenhouseMetadataData,
  RecordGreenhouseMetadataResponse,
  RecordProctoringFeedbackData,
  RecordProctoringFeedbackResult,
  RefineCopilotGuideData,
  RefineCopilotGuideResponse,
  RefineJdSelectionData,
  RefineJdSelectionResponse,
  RefineJobDescriptionData,
  RefineJobDescriptionResponse,
  RefreshSentEmailsData,
  RefreshSentEmailsResult,
  RegenerateCaseStudyData,
  RegenerateCaseStudyResponse,
  RegenerateCopilotGuideData,
  RegenerateCopilotGuideResponse,
  RemoveTeamMemberData,
  RemoveTeamMemberResult,
  RemoveTenantMemberData,
  RemoveTenantMemberResult,
  RequestRescheduleData,
  RequestRescheduleResponse,
  RescheduleCopilotRoundData,
  RescheduleCopilotRoundResponse,
  ResolveSimulationPersonaData,
  ResolveSimulationPersonaError,
  ResolveSimulationPersonaResponse,
  RestoreDeclinedData,
  RestoreDeclinedResponse,
  ResumePlannerSessionData,
  ResumePlannerSessionResponse,
  ReviewRescheduleData,
  ReviewRescheduleResponse,
  RevokePartnerCredentialByKeyIdData,
  RevokePartnerCredentialByKeyIdResponse,
  RevokePartnerCredentialData,
  RevokePartnerCredentialResult,
  RunCodingAssessmentCodeData,
  RunCodingAssessmentCodeResponse,
  SaveAssessmentConfigData,
  SaveAssessmentConfigResponse,
  SaveAssessmentRequirementsData,
  SaveAssessmentRequirementsResponse,
  SaveCopilotFeedbackData,
  SaveCopilotFeedbackResponse,
  SaveInterviewPlanDraftData,
  SaveInterviewPlanDraftResponse,
  ScheduleCopilotRoundData,
  ScheduleCopilotRoundResult,
  SearchSentEmailsData,
  SearchSentEmailsResponse,
  SendBookingInvitesData,
  SendBookingInvitesResult,
  SendCaseStudyChatMessageData,
  SendCopilotRoundInvitesData,
  SendCopilotRoundInvitesResult,
  SendTestEmailData,
  SendTestEmailResult,
  SetIntakeMetadataData,
  SetIntakeMetadataResponse,
  SetSelectionStatusData,
  SetSelectionStatusResponse,
  SingleAssessmentIntakeData,
  SingleAssessmentIntakeResult,
  SingleCopilotIntakeData,
  SingleCopilotIntakeResult,
  SingleInterviewIntakeData,
  SingleInterviewIntakeResult,
  SingleScreeningIntakeData,
  SingleScreeningIntakeResult,
  StartCandidateIntakeValidationData,
  StartCandidateIntakeValidationResponse,
  StartCodingAssessmentData,
  StartCodingAssessmentResponse,
  StartCopilotListeningData,
  StartCopilotListeningResponse,
  StartJobDesignGenerationData,
  StartJobDesignGenerationResponse,
  StartJobSetupGenerationData,
  StartJobSetupGenerationResponse,
  StartPlannerSessionData,
  StartPlannerSessionResult,
  StartPrescreenConversationData,
  StartPrescreenConversationResponse,
  StartSimulationData,
  StartSimulationError,
  StartSimulationResult,
  StopCopilotListeningData,
  StopCopilotListeningResponse,
  SubmitApplicationAnswersData,
  SubmitApplicationAnswersResponse,
  SubmitCodingAssessmentCodeData,
  SubmitCodingAssessmentCodeResponse,
  SuggestAssessmentDesignData,
  SuggestAssessmentDesignResult,
  SuggestCopilotQuestionsData,
  SuggestCopilotQuestionsResponse,
  SuggestCopilotStartData,
  SuggestCopilotStartResponse,
  SuggestInteractiveConfigData,
  SuggestInteractiveConfigResponse,
  SuggestQuestionsData,
  SuggestQuestionsResult,
  SuggestSubtopicsData,
  SuggestSubtopicsResponse,
  SuggestTopicsData,
  SuggestTopicsResponse,
  SyncCodingAssessmentDraftData,
  SyncCodingAssessmentDraftResponse,
  UnpublishJobData,
  UnpublishJobResponse,
  UpdateApplicationQuestionData,
  UpdateApplicationQuestionResponse,
  UpdateAssessmentAiProctoringData,
  UpdateAssessmentAiProctoringResponse,
  UpdateAssessmentInstructionsData,
  UpdateAssessmentInstructionsResponse,
  UpdateAssessmentLiveProctoringData,
  UpdateAssessmentLiveProctoringResponse,
  UpdateCopilotGuideData,
  UpdateCopilotGuideResponse,
  UpdateCurrentTenantData,
  UpdateCurrentTenantResponse,
  UpdateCurrentUserData,
  UpdateCurrentUserResponse,
  UpdateCustomInstructionsData,
  UpdateCustomInstructionsResponse,
  UpdateEmailTemplateData,
  UpdateEmailTemplateResponse,
  UpdateInterviewPlanRubricData,
  UpdateInterviewPlanRubricResponse,
  UpdateJobData,
  UpdateJobResponse,
  UpdateJobSetupStateData,
  UpdateJobSetupStateResponse,
  UpdateLiveProctoringData,
  UpdateLiveProctoringResponse,
  UpdateOfflineProctoringData,
  UpdateOfflineProctoringResponse,
  UpdatePartnerCredentialWebhookByKeyIdData,
  UpdatePartnerCredentialWebhookByKeyIdResponse,
  UpdatePartnerCredentialWebhookData,
  UpdatePartnerCredentialWebhookResponse,
  UpdateScreenerPlanData,
  UpdateScreenerPlanResponse,
  UpdateTeamMemberRoleData,
  UpdateTeamMemberRoleResult,
  UpdateTenantMemberRoleData,
  UpdateTenantMemberRoleResult,
  UploadJobDescriptionData,
  UploadJobDescriptionResult,
  UploadReferenceDocumentData,
  UploadReferenceDocumentResponse,
  UploadResumeForApplicationData,
  UploadResumeForApplicationResponse,
  UpsertApplicationData,
  UpsertApplicationResponse,
  UpsertBookingConfigData,
  UpsertBookingConfigResponse,
  V2HealthHealthGetData,
  V2HealthHealthGetResponse,
  WorkflowAssignReviewerData,
  WorkflowAssignReviewerResponse,
  WorkflowBulkAssignByAddedByData,
  WorkflowBulkAssignByAddedByResponse,
  WorkflowBulkAssignReviewerData,
  WorkflowBulkAssignReviewerResponse,
  WorkflowBulkChangeAssessmentDeadlineData,
  WorkflowBulkChangeAssessmentDeadlineResponse,
  WorkflowBulkChangeDeadlineData,
  WorkflowBulkChangeDeadlineResponse,
  WorkflowBulkRejectBelowData,
  WorkflowBulkRejectBelowResponse,
  WorkflowBulkSendReminderData,
  WorkflowBulkSendReminderResponse,
  WorkflowBulkTransitionData,
  WorkflowBulkTransitionResponse,
  WorkflowRejectBelowPreviewData,
  WorkflowRejectBelowPreviewResponse,
  WorkflowReminderPreviewData,
  WorkflowReminderPreviewResponse,
  WorkflowSubmitHumanReviewData,
  WorkflowSubmitHumanReviewResponse,
  WorkflowTransitionData,
  WorkflowTransitionResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getCurrentTenantPublicQueryKey = (
  options?: Options<GetCurrentTenantPublicData>,
) => createQueryKey('getCurrentTenantPublic', options);

/**
 * Get current tenant (public)
 *
 * Returns non-sensitive tenant identity — safe to call before the user has signed in. For full detail including settings, see `get_current_tenant`.
 */
export const getCurrentTenantPublicOptions = (
  options?: Options<GetCurrentTenantPublicData>,
) =>
  queryOptions<
    GetCurrentTenantPublicResponse,
    DefaultError,
    GetCurrentTenantPublicResponse,
    ReturnType<typeof getCurrentTenantPublicQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentTenantPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentTenantPublicQueryKey(options),
  });

export const getCurrentTenantQueryKey = (
  options?: Options<GetCurrentTenantData>,
) => createQueryKey('getCurrentTenant', options);

/**
 * Get the current tenant
 *
 * Returns full tenant detail including configuration and settings.
 */
export const getCurrentTenantOptions = (
  options?: Options<GetCurrentTenantData>,
) =>
  queryOptions<
    GetCurrentTenantResponse,
    DefaultError,
    GetCurrentTenantResponse,
    ReturnType<typeof getCurrentTenantQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentTenantQueryKey(options),
  });

/**
 * Update the current tenant
 *
 * Updates the caller's own tenant profile and self-service settings. Platform-managed fields are not exposed and cannot be changed through this endpoint.
 */
export const updateCurrentTenantMutation = (
  options?: Partial<Options<UpdateCurrentTenantData>>,
): UseMutationOptions<
  UpdateCurrentTenantResponse,
  DefaultError,
  Options<UpdateCurrentTenantData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCurrentTenantResponse,
    DefaultError,
    Options<UpdateCurrentTenantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCurrentTenant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMyPermissionsQueryKey = (
  options?: Options<GetMyPermissionsData>,
) => createQueryKey('getMyPermissions', options);

/**
 * Get caller's permissions for the current tenant
 *
 * Returns the authenticated user's tenant-level permissions, per-job permissions, and superuser flag. Account admins (manage_tenant_jobs) receive an empty job_permissions list — the frontend derives full job access from that permission.
 */
export const getMyPermissionsOptions = (
  options?: Options<GetMyPermissionsData>,
) =>
  queryOptions<
    GetMyPermissionsResponse,
    DefaultError,
    GetMyPermissionsResponse,
    ReturnType<typeof getMyPermissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyPermissionsQueryKey(options),
  });

export const pronounceWithTenantVoiceQueryKey = (
  options: Options<PronounceWithTenantVoiceData>,
) => createQueryKey('pronounceWithTenantVoice', options);

/**
 * Hear text in the tenant's interviewer voice
 *
 * Synthesizes short text (a company name) with the voice the tenant's AI interviewer speaks with and returns it as MP3. 400 when the text is blank or longer than 200 characters; 502 when speech synthesis fails.
 */
export const pronounceWithTenantVoiceOptions = (
  options: Options<PronounceWithTenantVoiceData>,
) =>
  queryOptions<
    PronounceWithTenantVoiceResponse,
    DefaultError,
    PronounceWithTenantVoiceResponse,
    ReturnType<typeof pronounceWithTenantVoiceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pronounceWithTenantVoice({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: pronounceWithTenantVoiceQueryKey(options),
  });

export const listTenantsQueryKey = (options?: Options<ListTenantsData>) =>
  createQueryKey('listTenants', options);

/**
 * List all tenants
 *
 * Returns all tenants, oldest first. Admin only.
 */
export const listTenantsOptions = (options?: Options<ListTenantsData>) =>
  queryOptions<
    ListTenantsResult,
    DefaultError,
    ListTenantsResult,
    ReturnType<typeof listTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenants({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantsQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const listTenantsInfiniteQueryKey = (
  options?: Options<ListTenantsData>,
): QueryKey<Options<ListTenantsData>> =>
  createQueryKey('listTenants', options, true);

/**
 * List all tenants
 *
 * Returns all tenants, oldest first. Admin only.
 */
export const listTenantsInfiniteOptions = (
  options?: Options<ListTenantsData>,
) =>
  infiniteQueryOptions<
    ListTenantsResult,
    DefaultError,
    InfiniteData<ListTenantsResult>,
    QueryKey<Options<ListTenantsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListTenantsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTenantsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTenants({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTenantsInfiniteQueryKey(options),
    },
  );

/**
 * Create a new tenant
 *
 * Creates a tenant and makes the caller its first admin. Fails if the domain is already taken. Admin only.
 */
export const createTenantMutation = (
  options?: Partial<Options<CreateTenantData>>,
): UseMutationOptions<
  CreateTenantResponse,
  DefaultError,
  Options<CreateTenantData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTenantResponse,
    DefaultError,
    Options<CreateTenantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTenant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTenantByIdQueryKey = (options: Options<GetTenantByIdData>) =>
  createQueryKey('getTenantById', options);

/**
 * Get a tenant by id
 *
 * Admin only.
 */
export const getTenantByIdOptions = (options: Options<GetTenantByIdData>) =>
  queryOptions<
    GetTenantByIdResponse,
    DefaultError,
    GetTenantByIdResponse,
    ReturnType<typeof getTenantByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTenantById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTenantByIdQueryKey(options),
  });

export const listTenantMembersQueryKey = (
  options?: Options<ListTenantMembersData>,
) => createQueryKey('listTenantMembers', options);

/**
 * List Tenant Members
 */
export const listTenantMembersOptions = (
  options?: Options<ListTenantMembersData>,
) =>
  queryOptions<
    ListTenantMembersResult,
    DefaultError,
    ListTenantMembersResult,
    ReturnType<typeof listTenantMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenantMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantMembersQueryKey(options),
  });

export const listTenantMembersInfiniteQueryKey = (
  options?: Options<ListTenantMembersData>,
): QueryKey<Options<ListTenantMembersData>> =>
  createQueryKey('listTenantMembers', options, true);

/**
 * List Tenant Members
 */
export const listTenantMembersInfiniteOptions = (
  options?: Options<ListTenantMembersData>,
) =>
  infiniteQueryOptions<
    ListTenantMembersResult,
    DefaultError,
    InfiniteData<ListTenantMembersResult>,
    QueryKey<Options<ListTenantMembersData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListTenantMembersData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTenantMembersData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTenantMembers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTenantMembersInfiniteQueryKey(options),
    },
  );

/**
 * Invite Tenant Member
 */
export const inviteTenantMemberMutation = (
  options?: Partial<Options<InviteTenantMemberData>>,
): UseMutationOptions<
  InviteTenantMemberResult,
  DefaultError,
  Options<InviteTenantMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteTenantMemberResult,
    DefaultError,
    Options<InviteTenantMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteTenantMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Tenant Member Role
 */
export const updateTenantMemberRoleMutation = (
  options?: Partial<Options<UpdateTenantMemberRoleData>>,
): UseMutationOptions<
  UpdateTenantMemberRoleResult,
  DefaultError,
  Options<UpdateTenantMemberRoleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTenantMemberRoleResult,
    DefaultError,
    Options<UpdateTenantMemberRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTenantMemberRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Tenant Member
 */
export const removeTenantMemberMutation = (
  options?: Partial<Options<RemoveTenantMemberData>>,
): UseMutationOptions<
  RemoveTenantMemberResult,
  DefaultError,
  Options<RemoveTenantMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveTenantMemberResult,
    DefaultError,
    Options<RemoveTenantMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeTenantMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTenantRolesQueryKey = (
  options?: Options<ListTenantRolesData>,
) => createQueryKey('listTenantRoles', options);

/**
 * List Tenant Roles
 */
export const listTenantRolesOptions = (
  options?: Options<ListTenantRolesData>,
) =>
  queryOptions<
    ListTenantRolesResponse,
    DefaultError,
    ListTenantRolesResponse,
    ReturnType<typeof listTenantRolesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTenantRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTenantRolesQueryKey(options),
  });

export const getApplicationQueryKey = (options: Options<GetApplicationData>) =>
  createQueryKey('getApplication', options);

/**
 * Get an application by id
 */
export const getApplicationOptions = (options: Options<GetApplicationData>) =>
  queryOptions<
    GetApplicationResponse,
    DefaultError,
    GetApplicationResponse,
    ReturnType<typeof getApplicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApplication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApplicationQueryKey(options),
  });

export const listApplicationsQueryKey = (
  options: Options<ListApplicationsData>,
) => createQueryKey('listApplications', options);

/**
 * List applications for a job
 */
export const listApplicationsOptions = (
  options: Options<ListApplicationsData>,
) =>
  queryOptions<
    ListApplicationsResult,
    DefaultError,
    ListApplicationsResult,
    ReturnType<typeof listApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listApplicationsQueryKey(options),
  });

export const listApplicationsInfiniteQueryKey = (
  options: Options<ListApplicationsData>,
): QueryKey<Options<ListApplicationsData>> =>
  createQueryKey('listApplications', options, true);

/**
 * List applications for a job
 */
export const listApplicationsInfiniteOptions = (
  options: Options<ListApplicationsData>,
) =>
  infiniteQueryOptions<
    ListApplicationsResult,
    DefaultError,
    InfiniteData<ListApplicationsResult>,
    QueryKey<Options<ListApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listApplicationsInfiniteQueryKey(options),
    },
  );

export const listInterviewingApplicationsQueryKey = (
  options: Options<ListInterviewingApplicationsData>,
) => createQueryKey('listInterviewingApplications', options);

/**
 * Paginated row list for the Applications-v2 page
 */
export const listInterviewingApplicationsOptions = (
  options: Options<ListInterviewingApplicationsData>,
) =>
  queryOptions<
    ListInterviewingApplicationsResult,
    DefaultError,
    ListInterviewingApplicationsResult,
    ReturnType<typeof listInterviewingApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewingApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewingApplicationsQueryKey(options),
  });

export const listInterviewingApplicationsInfiniteQueryKey = (
  options: Options<ListInterviewingApplicationsData>,
): QueryKey<Options<ListInterviewingApplicationsData>> =>
  createQueryKey('listInterviewingApplications', options, true);

/**
 * Paginated row list for the Applications-v2 page
 */
export const listInterviewingApplicationsInfiniteOptions = (
  options: Options<ListInterviewingApplicationsData>,
) =>
  infiniteQueryOptions<
    ListInterviewingApplicationsResult,
    DefaultError,
    InfiniteData<ListInterviewingApplicationsResult>,
    QueryKey<Options<ListInterviewingApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListInterviewingApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListInterviewingApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInterviewingApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listInterviewingApplicationsInfiniteQueryKey(options),
    },
  );

export const globalCandidateSearchQueryKey = (
  options?: Options<GlobalCandidateSearchData>,
) => createQueryKey('globalCandidateSearch', options);

/**
 * Cross-job candidate search (per-job RBAC scoped)
 */
export const globalCandidateSearchOptions = (
  options?: Options<GlobalCandidateSearchData>,
) =>
  queryOptions<
    GlobalCandidateSearchResponse,
    DefaultError,
    GlobalCandidateSearchResponse,
    ReturnType<typeof globalCandidateSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await globalCandidateSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: globalCandidateSearchQueryKey(options),
  });

export const globalCandidateSearchInfiniteQueryKey = (
  options?: Options<GlobalCandidateSearchData>,
): QueryKey<Options<GlobalCandidateSearchData>> =>
  createQueryKey('globalCandidateSearch', options, true);

/**
 * Cross-job candidate search (per-job RBAC scoped)
 */
export const globalCandidateSearchInfiniteOptions = (
  options?: Options<GlobalCandidateSearchData>,
) =>
  infiniteQueryOptions<
    GlobalCandidateSearchResponse,
    DefaultError,
    InfiniteData<GlobalCandidateSearchResponse>,
    QueryKey<Options<GlobalCandidateSearchData>>,
    | number
    | Pick<
        QueryKey<Options<GlobalCandidateSearchData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GlobalCandidateSearchData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await globalCandidateSearch({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: globalCandidateSearchInfiniteQueryKey(options),
    },
  );

export const getInterviewingCountsQueryKey = (
  options: Options<GetInterviewingCountsData>,
) => createQueryKey('getInterviewingCounts', options);

/**
 * Aggregate bucket + board counts for the Applications-v2 page
 */
export const getInterviewingCountsOptions = (
  options: Options<GetInterviewingCountsData>,
) =>
  queryOptions<
    GetInterviewingCountsResponse,
    DefaultError,
    GetInterviewingCountsResponse,
    ReturnType<typeof getInterviewingCountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewingCounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewingCountsQueryKey(options),
  });

export const getListingFilterOptionsQueryKey = (
  options: Options<GetListingFilterOptionsData>,
) => createQueryKey('getListingFilterOptions', options);

/**
 * Selectable values (batches) for the Applications-v2 listing filters
 */
export const getListingFilterOptionsOptions = (
  options: Options<GetListingFilterOptionsData>,
) =>
  queryOptions<
    GetListingFilterOptionsResponse,
    DefaultError,
    GetListingFilterOptionsResponse,
    ReturnType<typeof getListingFilterOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getListingFilterOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getListingFilterOptionsQueryKey(options),
  });

export const listBoardQueryKey = (options: Options<ListBoardData>) =>
  createQueryKey('listBoard', options);

/**
 * One page of one All Candidates column
 */
export const listBoardOptions = (options: Options<ListBoardData>) =>
  queryOptions<
    ListBoardResponse,
    DefaultError,
    ListBoardResponse,
    ReturnType<typeof listBoardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listBoard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listBoardQueryKey(options),
  });

export const listBoardInfiniteQueryKey = (
  options: Options<ListBoardData>,
): QueryKey<Options<ListBoardData>> =>
  createQueryKey('listBoard', options, true);

/**
 * One page of one All Candidates column
 */
export const listBoardInfiniteOptions = (options: Options<ListBoardData>) =>
  infiniteQueryOptions<
    ListBoardResponse,
    DefaultError,
    InfiniteData<ListBoardResponse>,
    QueryKey<Options<ListBoardData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListBoardData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListBoardData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listBoard({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listBoardInfiniteQueryKey(options),
    },
  );

export const getBoardSummaryQueryKey = (
  options: Options<GetBoardSummaryData>,
) => createQueryKey('getBoardSummary', options);

/**
 * Every All Candidates stage's count, and who added candidates to the job
 */
export const getBoardSummaryOptions = (options: Options<GetBoardSummaryData>) =>
  queryOptions<
    GetBoardSummaryResponse,
    DefaultError,
    GetBoardSummaryResponse,
    ReturnType<typeof getBoardSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBoardSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBoardSummaryQueryKey(options),
  });

export const getBoardRowQueryKey = (options: Options<GetBoardRowData>) =>
  createQueryKey('getBoardRow', options);

/**
 * One candidate as the All Candidates board shows them
 */
export const getBoardRowOptions = (options: Options<GetBoardRowData>) =>
  queryOptions<
    GetBoardRowResponse,
    DefaultError,
    GetBoardRowResponse,
    ReturnType<typeof getBoardRowQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBoardRow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBoardRowQueryKey(options),
  });

export const getBoardExportOptionsQueryKey = (
  options: Options<GetBoardExportOptionsData>,
) => createQueryKey('getBoardExportOptions', options);

/**
 * What the All Candidates Export offers, counted per tab
 */
export const getBoardExportOptionsOptions = (
  options: Options<GetBoardExportOptionsData>,
) =>
  queryOptions<
    GetBoardExportOptionsResponse,
    DefaultError,
    GetBoardExportOptionsResponse,
    ReturnType<typeof getBoardExportOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBoardExportOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBoardExportOptionsQueryKey(options),
  });

export const exportBoardQueryKey = (options: Options<ExportBoardData>) =>
  createQueryKey('exportBoard', options);

/**
 * Download the All Candidates board as an .xlsx
 */
export const exportBoardOptions = (options: Options<ExportBoardData>) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof exportBoardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportBoard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exportBoardQueryKey(options),
  });

export const getActiveEmailTemplateQueryKey = (
  options: Options<GetActiveEmailTemplateData>,
) => createQueryKey('getActiveEmailTemplate', options);

/**
 * Most-recent active email template for a (job, trigger_event) pair
 */
export const getActiveEmailTemplateOptions = (
  options: Options<GetActiveEmailTemplateData>,
) =>
  queryOptions<
    GetActiveEmailTemplateResponse,
    DefaultError,
    GetActiveEmailTemplateResponse,
    ReturnType<typeof getActiveEmailTemplateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveEmailTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveEmailTemplateQueryKey(options),
  });

export const getGreenhouseMetadataQueryKey = (
  options: Options<GetGreenhouseMetadataData>,
) => createQueryKey('getGreenhouseMetadata', options);

/**
 * Get Greenhouse ATS metadata for an application
 */
export const getGreenhouseMetadataOptions = (
  options: Options<GetGreenhouseMetadataData>,
) =>
  queryOptions<
    GetGreenhouseMetadataResponse,
    DefaultError,
    GetGreenhouseMetadataResponse,
    ReturnType<typeof getGreenhouseMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGreenhouseMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGreenhouseMetadataQueryKey(options),
  });

/**
 * Record Greenhouse ATS callback metadata on an application
 */
export const recordGreenhouseMetadataMutation = (
  options?: Partial<Options<RecordGreenhouseMetadataData>>,
): UseMutationOptions<
  RecordGreenhouseMetadataResponse,
  DefaultError,
  Options<RecordGreenhouseMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordGreenhouseMetadataResponse,
    DefaultError,
    Options<RecordGreenhouseMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordGreenhouseMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const exportApplicationsQueryKey = (
  options: Options<ExportApplicationsData>,
) => createQueryKey('exportApplications', options);

/**
 * Export applications as XLSX, CSV, or JSON
 */
export const exportApplicationsOptions = (
  options: Options<ExportApplicationsData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof exportApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exportApplicationsQueryKey(options),
  });

export const getExportOptionsQueryKey = (
  options: Options<GetExportOptionsData>,
) => createQueryKey('getExportOptions', options);

/**
 * Get export modal option counts
 */
export const getExportOptionsOptions = (
  options: Options<GetExportOptionsData>,
) =>
  queryOptions<
    GetExportOptionsResponse,
    DefaultError,
    GetExportOptionsResponse,
    ReturnType<typeof getExportOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExportOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExportOptionsQueryKey(options),
  });

/**
 * Create or retrieve an application for a (job, user) pair
 */
export const upsertApplicationMutation = (
  options?: Partial<Options<UpsertApplicationData>>,
): UseMutationOptions<
  UpsertApplicationResponse,
  DefaultError,
  Options<UpsertApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertApplicationResponse,
    DefaultError,
    Options<UpsertApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set intake (pre-interview) metadata on an application
 */
export const setIntakeMetadataMutation = (
  options?: Partial<Options<SetIntakeMetadataData>>,
): UseMutationOptions<
  SetIntakeMetadataResponse,
  DefaultError,
  Options<SetIntakeMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    SetIntakeMetadataResponse,
    DefaultError,
    Options<SetIntakeMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setIntakeMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set the AI selection status on an application
 */
export const setSelectionStatusMutation = (
  options?: Partial<Options<SetSelectionStatusData>>,
): UseMutationOptions<
  SetSelectionStatusResponse,
  DefaultError,
  Options<SetSelectionStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    SetSelectionStatusResponse,
    DefaultError,
    Options<SetSelectionStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setSelectionStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listJobsQueryKey = (options?: Options<ListJobsData>) =>
  createQueryKey('listJobs', options);

/**
 * List jobs
 */
export const listJobsOptions = (options?: Options<ListJobsData>) =>
  queryOptions<
    ListJobsResult,
    DefaultError,
    ListJobsResult,
    ReturnType<typeof listJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listJobsQueryKey(options),
  });

export const listJobsInfiniteQueryKey = (
  options?: Options<ListJobsData>,
): QueryKey<Options<ListJobsData>> => createQueryKey('listJobs', options, true);

/**
 * List jobs
 */
export const listJobsInfiniteOptions = (options?: Options<ListJobsData>) =>
  infiniteQueryOptions<
    ListJobsResult,
    DefaultError,
    InfiniteData<ListJobsResult>,
    QueryKey<Options<ListJobsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListJobsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListJobsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listJobs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listJobsInfiniteQueryKey(options),
    },
  );

/**
 * Update a job
 */
export const updateJobMutation = (
  options?: Partial<Options<UpdateJobData>>,
): UseMutationOptions<
  UpdateJobResponse,
  DefaultError,
  Options<UpdateJobData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateJobResponse,
    DefaultError,
    Options<UpdateJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new job
 */
export const createJobMutation = (
  options?: Partial<Options<CreateJobData>>,
): UseMutationOptions<
  CreateJobResponse,
  DefaultError,
  Options<CreateJobData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateJobResponse,
    DefaultError,
    Options<CreateJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJobQueryKey = (options: Options<GetJobData>) =>
  createQueryKey('getJob', options);

/**
 * Get a job by id
 */
export const getJobOptions = (options: Options<GetJobData>) =>
  queryOptions<
    GetJobResponse,
    DefaultError,
    GetJobResponse,
    ReturnType<typeof getJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobQueryKey(options),
  });

export const listDocumentsQueryKey = (options: Options<ListDocumentsData>) =>
  createQueryKey('listDocuments', options);

/**
 * List documents attached to a job
 */
export const listDocumentsOptions = (options: Options<ListDocumentsData>) =>
  queryOptions<
    ListDocumentsResult,
    DefaultError,
    ListDocumentsResult,
    ReturnType<typeof listDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDocumentsQueryKey(options),
  });

export const getDocumentDownloadUrlQueryKey = (
  options: Options<GetDocumentDownloadUrlData>,
) => createQueryKey('getDocumentDownloadUrl', options);

/**
 * Get a signed download URL for a document
 */
export const getDocumentDownloadUrlOptions = (
  options: Options<GetDocumentDownloadUrlData>,
) =>
  queryOptions<
    GetDocumentDownloadUrlResponse,
    DefaultError,
    GetDocumentDownloadUrlResponse,
    ReturnType<typeof getDocumentDownloadUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentDownloadUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentDownloadUrlQueryKey(options),
  });

export const getDocumentContentQueryKey = (
  options: Options<GetDocumentContentData>,
) => createQueryKey('getDocumentContent', options);

/**
 * Get the text content of a document
 */
export const getDocumentContentOptions = (
  options: Options<GetDocumentContentData>,
) =>
  queryOptions<
    GetDocumentContentResponse,
    DefaultError,
    GetDocumentContentResponse,
    ReturnType<typeof getDocumentContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentContentQueryKey(options),
  });

/**
 * Save the stage choice and notes of a job in setup
 */
export const updateJobSetupStateMutation = (
  options?: Partial<Options<UpdateJobSetupStateData>>,
): UseMutationOptions<
  UpdateJobSetupStateResponse,
  DefaultError,
  Options<UpdateJobSetupStateData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateJobSetupStateResponse,
    DefaultError,
    Options<UpdateJobSetupStateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateJobSetupState({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start generating the plans of chosen setup stages in the background
 */
export const startJobSetupGenerationMutation = (
  options?: Partial<Options<StartJobSetupGenerationData>>,
): UseMutationOptions<
  StartJobSetupGenerationResponse,
  DefaultError,
  Options<StartJobSetupGenerationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartJobSetupGenerationResponse,
    DefaultError,
    Options<StartJobSetupGenerationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startJobSetupGeneration({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start generating the design of a stage a set-up job runs but has none for
 */
export const startJobDesignGenerationMutation = (
  options?: Partial<Options<StartJobDesignGenerationData>>,
): UseMutationOptions<
  StartJobDesignGenerationResponse,
  DefaultError,
  Options<StartJobDesignGenerationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartJobDesignGenerationResponse,
    DefaultError,
    Options<StartJobDesignGenerationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startJobDesignGeneration({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Archive (soft-delete) a job
 */
export const archiveJobMutation = (
  options?: Partial<Options<ArchiveJobData>>,
): UseMutationOptions<
  ArchiveJobResponse,
  DefaultError,
  Options<ArchiveJobData>
> => {
  const mutationOptions: UseMutationOptions<
    ArchiveJobResponse,
    DefaultError,
    Options<ArchiveJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Publish a job
 */
export const publishJobMutation = (
  options?: Partial<Options<PublishJobData>>,
): UseMutationOptions<
  PublishJobResponse,
  DefaultError,
  Options<PublishJobData>
> => {
  const mutationOptions: UseMutationOptions<
    PublishJobResponse,
    DefaultError,
    Options<PublishJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unpublish a job
 */
export const unpublishJobMutation = (
  options?: Partial<Options<UnpublishJobData>>,
): UseMutationOptions<
  UnpublishJobResponse,
  DefaultError,
  Options<UnpublishJobData>
> => {
  const mutationOptions: UseMutationOptions<
    UnpublishJobResponse,
    DefaultError,
    Options<UnpublishJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a reference document to a job
 */
export const uploadReferenceDocumentMutation = (
  options?: Partial<Options<UploadReferenceDocumentData>>,
): UseMutationOptions<
  UploadReferenceDocumentResponse,
  DefaultError,
  Options<UploadReferenceDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadReferenceDocumentResponse,
    DefaultError,
    Options<UploadReferenceDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadReferenceDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a job description document — stores to GCS and extracts text
 */
export const uploadJobDescriptionMutation = (
  options?: Partial<Options<UploadJobDescriptionData>>,
): UseMutationOptions<
  UploadJobDescriptionResult,
  DefaultError,
  Options<UploadJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadJobDescriptionResult,
    DefaultError,
    Options<UploadJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a document from a job
 */
export const deleteDocumentMutation = (
  options?: Partial<Options<DeleteDocumentData>>,
): UseMutationOptions<
  DeleteDocumentResponse,
  DefaultError,
  Options<DeleteDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteDocumentResponse,
    DefaultError,
    Options<DeleteDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update live proctoring settings for a job
 */
export const updateLiveProctoringMutation = (
  options?: Partial<Options<UpdateLiveProctoringData>>,
): UseMutationOptions<
  UpdateLiveProctoringResponse,
  DefaultError,
  Options<UpdateLiveProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLiveProctoringResponse,
    DefaultError,
    Options<UpdateLiveProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLiveProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update offline proctoring settings for a job
 */
export const updateOfflineProctoringMutation = (
  options?: Partial<Options<UpdateOfflineProctoringData>>,
): UseMutationOptions<
  UpdateOfflineProctoringResponse,
  DefaultError,
  Options<UpdateOfflineProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateOfflineProctoringResponse,
    DefaultError,
    Options<UpdateOfflineProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOfflineProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Replace the custom candidate instructions for a job (auto-instructions preserved)
 */
export const updateCustomInstructionsMutation = (
  options?: Partial<Options<UpdateCustomInstructionsData>>,
): UseMutationOptions<
  UpdateCustomInstructionsResponse,
  DefaultError,
  Options<UpdateCustomInstructionsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCustomInstructionsResponse,
    DefaultError,
    Options<UpdateCustomInstructionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCustomInstructions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookingConfigQueryKey = (
  options: Options<GetBookingConfigData>,
) => createQueryKey('getBookingConfig', options);

/**
 * Get Booking Config
 */
export const getBookingConfigOptions = (
  options: Options<GetBookingConfigData>,
) =>
  queryOptions<
    GetBookingConfigResponse,
    DefaultError,
    GetBookingConfigResponse,
    ReturnType<typeof getBookingConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingConfigQueryKey(options),
  });

/**
 * Upsert Booking Config
 */
export const upsertBookingConfigMutation = (
  options?: Partial<Options<UpsertBookingConfigData>>,
): UseMutationOptions<
  UpsertBookingConfigResponse,
  DefaultError,
  Options<UpsertBookingConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertBookingConfigResponse,
    DefaultError,
    Options<UpsertBookingConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertBookingConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBookingSlotsQueryKey = (
  options: Options<GetBookingSlotsData>,
) => createQueryKey('getBookingSlots', options);

/**
 * Get Booking Slots
 */
export const getBookingSlotsOptions = (options: Options<GetBookingSlotsData>) =>
  queryOptions<
    GetBookingSlotsResponse,
    DefaultError,
    GetBookingSlotsResponse,
    ReturnType<typeof getBookingSlotsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingSlots({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingSlotsQueryKey(options),
  });

export const getBookingStatusQueryKey = (
  options?: Options<GetBookingStatusData>,
) => createQueryKey('getBookingStatus', options);

/**
 * Get Booking Status
 *
 * Booking status as a list. Pass ``job_id`` for a whole job's pipeline, or ``interview_id``
 * for one interview (returned as a single-item list). Exactly one of the two is required.
 *
 * ``interview_ids`` scopes a job read to the page the caller renders, and is required with
 * ``job_id``: unscoped, the response carries a row per candidate on the job, which is thousands on
 * the largest ones, and the pipeline re-reads on every window focus. It applies only to a
 * ``job_id`` read, and is rejected rather than ignored alongside ``interview_id``.
 */
export const getBookingStatusOptions = (
  options?: Options<GetBookingStatusData>,
) =>
  queryOptions<
    GetBookingStatusResponse,
    DefaultError,
    GetBookingStatusResponse,
    ReturnType<typeof getBookingStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingStatusQueryKey(options),
  });

export const listPendingBookingInvitesQueryKey = (
  options: Options<ListPendingBookingInvitesData>,
) => createQueryKey('listPendingBookingInvites', options);

/**
 * List Pending Booking Invites
 *
 * Candidates invited before Calendar Booking was enabled who still hold no booking link.
 */
export const listPendingBookingInvitesOptions = (
  options: Options<ListPendingBookingInvitesData>,
) =>
  queryOptions<
    ListPendingBookingInvitesResult,
    DefaultError,
    ListPendingBookingInvitesResult,
    ReturnType<typeof listPendingBookingInvitesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPendingBookingInvites({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPendingBookingInvitesQueryKey(options),
  });

export const listPendingBookingInvitesInfiniteQueryKey = (
  options: Options<ListPendingBookingInvitesData>,
): QueryKey<Options<ListPendingBookingInvitesData>> =>
  createQueryKey('listPendingBookingInvites', options, true);

/**
 * List Pending Booking Invites
 *
 * Candidates invited before Calendar Booking was enabled who still hold no booking link.
 */
export const listPendingBookingInvitesInfiniteOptions = (
  options: Options<ListPendingBookingInvitesData>,
) =>
  infiniteQueryOptions<
    ListPendingBookingInvitesResult,
    DefaultError,
    InfiniteData<ListPendingBookingInvitesResult>,
    QueryKey<Options<ListPendingBookingInvitesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListPendingBookingInvitesData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListPendingBookingInvitesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPendingBookingInvites({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listPendingBookingInvitesInfiniteQueryKey(options),
    },
  );

export const getBookingIcsQueryKey = (options: Options<GetBookingIcsData>) =>
  createQueryKey('getBookingIcs', options);

/**
 * Get Booking Ics
 */
export const getBookingIcsOptions = (options: Options<GetBookingIcsData>) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getBookingIcsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBookingIcs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBookingIcsQueryKey(options),
  });

/**
 * Book Slot
 */
export const bookSlotMutation = (
  options?: Partial<Options<BookSlotData>>,
): UseMutationOptions<
  BookSlotResponse,
  DefaultError,
  Options<BookSlotData>
> => {
  const mutationOptions: UseMutationOptions<
    BookSlotResponse,
    DefaultError,
    Options<BookSlotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookSlot({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Reschedule
 */
export const requestRescheduleMutation = (
  options?: Partial<Options<RequestRescheduleData>>,
): UseMutationOptions<
  RequestRescheduleResponse,
  DefaultError,
  Options<RequestRescheduleData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestRescheduleResponse,
    DefaultError,
    Options<RequestRescheduleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestReschedule({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Review Reschedule
 */
export const reviewRescheduleMutation = (
  options?: Partial<Options<ReviewRescheduleData>>,
): UseMutationOptions<
  ReviewRescheduleResponse,
  DefaultError,
  Options<ReviewRescheduleData>
> => {
  const mutationOptions: UseMutationOptions<
    ReviewRescheduleResponse,
    DefaultError,
    Options<ReviewRescheduleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reviewReschedule({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Declined
 */
export const restoreDeclinedMutation = (
  options?: Partial<Options<RestoreDeclinedData>>,
): UseMutationOptions<
  RestoreDeclinedResponse,
  DefaultError,
  Options<RestoreDeclinedData>
> => {
  const mutationOptions: UseMutationOptions<
    RestoreDeclinedResponse,
    DefaultError,
    Options<RestoreDeclinedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restoreDeclined({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Booking Invites
 *
 * Send the booking invite to candidates who were invited before booking was enabled.
 */
export const sendBookingInvitesMutation = (
  options?: Partial<Options<SendBookingInvitesData>>,
): UseMutationOptions<
  SendBookingInvitesResult,
  DefaultError,
  Options<SendBookingInvitesData>
> => {
  const mutationOptions: UseMutationOptions<
    SendBookingInvitesResult,
    DefaultError,
    Options<SendBookingInvitesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendBookingInvites({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Booking Unsubscribe
 */
export const bookingUnsubscribeMutation = (
  options?: Partial<Options<BookingUnsubscribeData>>,
): UseMutationOptions<
  BookingUnsubscribeResponse,
  DefaultError,
  Options<BookingUnsubscribeData>
> => {
  const mutationOptions: UseMutationOptions<
    BookingUnsubscribeResponse,
    DefaultError,
    Options<BookingUnsubscribeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookingUnsubscribe({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Booking Withdraw
 */
export const bookingWithdrawMutation = (
  options?: Partial<Options<BookingWithdrawData>>,
): UseMutationOptions<
  BookingWithdrawResponse,
  DefaultError,
  Options<BookingWithdrawData>
> => {
  const mutationOptions: UseMutationOptions<
    BookingWithdrawResponse,
    DefaultError,
    Options<BookingWithdrawData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bookingWithdraw({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listCopilotRoundsQueryKey = (
  options: Options<ListCopilotRoundsData>,
) => createQueryKey('listCopilotRounds', options);

/**
 * List Copilot Rounds
 *
 * Who is in this job's round. The recruiter's view, scoped by job.
 */
export const listCopilotRoundsOptions = (
  options: Options<ListCopilotRoundsData>,
) =>
  queryOptions<
    ListCopilotRoundsResult,
    DefaultError,
    ListCopilotRoundsResult,
    ReturnType<typeof listCopilotRoundsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCopilotRounds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCopilotRoundsQueryKey(options),
  });

export const listMyCopilotRoundsQueryKey = (
  options?: Options<ListMyCopilotRoundsData>,
) => createQueryKey('listMyCopilotRounds', options);

/**
 * List My Copilot Rounds
 *
 * The rounds assigned to the caller. Takes no job_id on purpose.
 *
 * An interviewer has no job-wide candidate permission, so there is no job for
 * them to ask about; the rounds naming them are the whole of what they see.
 */
export const listMyCopilotRoundsOptions = (
  options?: Options<ListMyCopilotRoundsData>,
) =>
  queryOptions<
    ListMyCopilotRoundsResponse,
    DefaultError,
    ListMyCopilotRoundsResponse,
    ReturnType<typeof listMyCopilotRoundsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyCopilotRounds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyCopilotRoundsQueryKey(options),
  });

export const getMyCopilotRoundQueryKey = (
  options: Options<GetMyCopilotRoundData>,
) => createQueryKey('getMyCopilotRound', options);

/**
 * Get My Copilot Round
 */
export const getMyCopilotRoundOptions = (
  options: Options<GetMyCopilotRoundData>,
) =>
  queryOptions<
    GetMyCopilotRoundResponse,
    DefaultError,
    GetMyCopilotRoundResponse,
    ReturnType<typeof getMyCopilotRoundQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyCopilotRound({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyCopilotRoundQueryKey(options),
  });

export const getCopilotRoundQueryKey = (
  options: Options<GetCopilotRoundData>,
) => createQueryKey('getCopilotRound', options);

/**
 * Get Copilot Round
 *
 * This job's round and its guide, or null when it has none.
 *
 * Singular, and separate from `/copilot/rounds`, which lists the candidates in
 * the round rather than the round itself.
 */
export const getCopilotRoundOptions = (options: Options<GetCopilotRoundData>) =>
  queryOptions<
    GetCopilotRoundResponse,
    DefaultError,
    GetCopilotRoundResponse,
    ReturnType<typeof getCopilotRoundQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCopilotRound({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCopilotRoundQueryKey(options),
  });

export const getApplicationCopilotRoundQueryKey = (
  options: Options<GetApplicationCopilotRoundData>,
) => createQueryKey('getApplicationCopilotRound', options);

/**
 * Get Application Copilot Round
 *
 * The candidate's copilot round and its submitted feedback, for the hiring
 * team. Null when the candidate has no copilot round.
 */
export const getApplicationCopilotRoundOptions = (
  options: Options<GetApplicationCopilotRoundData>,
) =>
  queryOptions<
    GetApplicationCopilotRoundResponse,
    DefaultError,
    GetApplicationCopilotRoundResponse,
    ReturnType<typeof getApplicationCopilotRoundQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApplicationCopilotRound({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApplicationCopilotRoundQueryKey(options),
  });

export const getCopilotTranscriptQueryKey = (
  options: Options<GetCopilotTranscriptData>,
) => createQueryKey('getCopilotTranscript', options);

/**
 * Get Copilot Transcript
 *
 * What has been heard so far. Polled by the round page while a call runs.
 */
export const getCopilotTranscriptOptions = (
  options: Options<GetCopilotTranscriptData>,
) =>
  queryOptions<
    GetCopilotTranscriptResponse,
    DefaultError,
    GetCopilotTranscriptResponse,
    ReturnType<typeof getCopilotTranscriptQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCopilotTranscript({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCopilotTranscriptQueryKey(options),
  });

export const getCopilotFeedbackQueryKey = (
  options: Options<GetCopilotFeedbackData>,
) => createQueryKey('getCopilotFeedback', options);

/**
 * Get Copilot Feedback
 *
 * The interviewer's own feedback, or a blank form on the guide's areas. Never R41's.
 */
export const getCopilotFeedbackOptions = (
  options: Options<GetCopilotFeedbackData>,
) =>
  queryOptions<
    GetCopilotFeedbackResponse,
    DefaultError,
    GetCopilotFeedbackResponse,
    ReturnType<typeof getCopilotFeedbackQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCopilotFeedback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCopilotFeedbackQueryKey(options),
  });

/**
 * Schedule Copilot Round
 */
export const scheduleCopilotRoundMutation = (
  options?: Partial<Options<ScheduleCopilotRoundData>>,
): UseMutationOptions<
  ScheduleCopilotRoundResult,
  DefaultError,
  Options<ScheduleCopilotRoundData>
> => {
  const mutationOptions: UseMutationOptions<
    ScheduleCopilotRoundResult,
    DefaultError,
    Options<ScheduleCopilotRoundData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await scheduleCopilotRound({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Copilot Round Invites
 *
 * Sending is per recipient, so this answers 200 with a per-recipient result.
 *
 * A candidate's address failing must not hide that the interviewer's landed.
 */
export const sendCopilotRoundInvitesMutation = (
  options?: Partial<Options<SendCopilotRoundInvitesData>>,
): UseMutationOptions<
  SendCopilotRoundInvitesResult,
  DefaultError,
  Options<SendCopilotRoundInvitesData>
> => {
  const mutationOptions: UseMutationOptions<
    SendCopilotRoundInvitesResult,
    DefaultError,
    Options<SendCopilotRoundInvitesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendCopilotRoundInvites({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mark Copilot Round No Show
 *
 * Record that a scheduled call did not happen. Leaves the candidate's stage alone.
 */
export const markCopilotRoundNoShowMutation = (
  options?: Partial<Options<MarkCopilotRoundNoShowData>>,
): UseMutationOptions<
  MarkCopilotRoundNoShowResponse,
  DefaultError,
  Options<MarkCopilotRoundNoShowData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkCopilotRoundNoShowResponse,
    DefaultError,
    Options<MarkCopilotRoundNoShowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markCopilotRoundNoShow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reschedule Copilot Round
 *
 * Book a no-show round again at a new time. Send the invites after, through `/send-invites`.
 */
export const rescheduleCopilotRoundMutation = (
  options?: Partial<Options<RescheduleCopilotRoundData>>,
): UseMutationOptions<
  RescheduleCopilotRoundResponse,
  DefaultError,
  Options<RescheduleCopilotRoundData>
> => {
  const mutationOptions: UseMutationOptions<
    RescheduleCopilotRoundResponse,
    DefaultError,
    Options<RescheduleCopilotRoundData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await rescheduleCopilotRound({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start Copilot Listening
 *
 * Hand the browser somewhere to publish the call's audio.
 *
 * A mutation, not a read: it moves the round to in progress, and the address
 * it returns expires, so nothing about it is safe to repeat or cache.
 */
export const startCopilotListeningMutation = (
  options?: Partial<Options<StartCopilotListeningData>>,
): UseMutationOptions<
  StartCopilotListeningResponse,
  DefaultError,
  Options<StartCopilotListeningData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCopilotListeningResponse,
    DefaultError,
    Options<StartCopilotListeningData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCopilotListening({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Stop Copilot Listening
 *
 * Close the round and answer with the record it ends on.
 *
 * Returns the transcript rather than an acknowledgement so the page can render
 * the finished round from this one response, without a poll that might arrive
 * before the write it is waiting for.
 */
export const stopCopilotListeningMutation = (
  options?: Partial<Options<StopCopilotListeningData>>,
): UseMutationOptions<
  StopCopilotListeningResponse,
  DefaultError,
  Options<StopCopilotListeningData>
> => {
  const mutationOptions: UseMutationOptions<
    StopCopilotListeningResponse,
    DefaultError,
    Options<StopCopilotListeningData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await stopCopilotListening({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Copilot Round
 *
 * Generate the guide, which is what creates the round.
 *
 * Runs a model call, so it is slow by the standards of everything else here:
 * about a minute. Verb-shaped rather than a POST to `/copilot/rounds`, which
 * already means the candidates in the round.
 */
export const createCopilotRoundMutation = (
  options?: Partial<Options<CreateCopilotRoundData>>,
): UseMutationOptions<
  CreateCopilotRoundResponse,
  DefaultError,
  Options<CreateCopilotRoundData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCopilotRoundResponse,
    DefaultError,
    Options<CreateCopilotRoundData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCopilotRound({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Copilot Guide
 *
 * Save the recruiter's own wording over the model's.
 *
 * Answers with the whole round, not an acknowledgement, so the page renders
 * what was stored rather than what it hoped was stored.
 */
export const updateCopilotGuideMutation = (
  options?: Partial<Options<UpdateCopilotGuideData>>,
): UseMutationOptions<
  UpdateCopilotGuideResponse,
  DefaultError,
  Options<UpdateCopilotGuideData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCopilotGuideResponse,
    DefaultError,
    Options<UpdateCopilotGuideData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCopilotGuide({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refine Copilot Guide
 *
 * Write the guide again with one instruction applied.
 *
 * As slow as creating the round, and for the same reason: it is the same model
 * call with the current guide in front of it.
 */
export const refineCopilotGuideMutation = (
  options?: Partial<Options<RefineCopilotGuideData>>,
): UseMutationOptions<
  RefineCopilotGuideResponse,
  DefaultError,
  Options<RefineCopilotGuideData>
> => {
  const mutationOptions: UseMutationOptions<
    RefineCopilotGuideResponse,
    DefaultError,
    Options<RefineCopilotGuideData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refineCopilotGuide({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete Copilot Guide Item
 *
 * Write the area and the nudges around a question the recruiter typed.
 *
 * Stores nothing: the answer fills the row in their editor, and is written
 * when they save the guide. A POST rather than a GET because it costs a model
 * call, and a GET that spends money is a GET somebody will cache.
 */
export const completeCopilotGuideItemMutation = (
  options?: Partial<Options<CompleteCopilotGuideItemData>>,
): UseMutationOptions<
  CompleteCopilotGuideItemResponse,
  DefaultError,
  Options<CompleteCopilotGuideItemData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteCopilotGuideItemResponse,
    DefaultError,
    Options<CompleteCopilotGuideItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeCopilotGuideItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regenerate Copilot Guide
 *
 * Write the plan again from the posting and the round's context.
 *
 * Replaces every row, including questions the recruiter wrote, so the screen
 * asks before calling it.
 */
export const regenerateCopilotGuideMutation = (
  options?: Partial<Options<RegenerateCopilotGuideData>>,
): UseMutationOptions<
  RegenerateCopilotGuideResponse,
  DefaultError,
  Options<RegenerateCopilotGuideData>
> => {
  const mutationOptions: UseMutationOptions<
    RegenerateCopilotGuideResponse,
    DefaultError,
    Options<RegenerateCopilotGuideData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await regenerateCopilotGuide({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest Copilot Questions
 *
 * A few questions for the area the call is in, for the interviewer to read out.
 *
 * A POST rather than a GET because it costs a model call.
 */
export const suggestCopilotQuestionsMutation = (
  options?: Partial<Options<SuggestCopilotQuestionsData>>,
): UseMutationOptions<
  SuggestCopilotQuestionsResponse,
  DefaultError,
  Options<SuggestCopilotQuestionsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestCopilotQuestionsResponse,
    DefaultError,
    Options<SuggestCopilotQuestionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestCopilotQuestions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save Copilot Feedback
 *
 * Save the interviewer's edits, and submit them when asked. The areas stay as drafted.
 */
export const saveCopilotFeedbackMutation = (
  options?: Partial<Options<SaveCopilotFeedbackData>>,
): UseMutationOptions<
  SaveCopilotFeedbackResponse,
  DefaultError,
  Options<SaveCopilotFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveCopilotFeedbackResponse,
    DefaultError,
    Options<SaveCopilotFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveCopilotFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest Copilot Start
 *
 * Work out, once, which area this candidate's round should open with. Returns the round.
 */
export const suggestCopilotStartMutation = (
  options?: Partial<Options<SuggestCopilotStartData>>,
): UseMutationOptions<
  SuggestCopilotStartResponse,
  DefaultError,
  Options<SuggestCopilotStartData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestCopilotStartResponse,
    DefaultError,
    Options<SuggestCopilotStartData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestCopilotStart({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTeamMembersQueryKey = (
  options: Options<ListTeamMembersData>,
) => createQueryKey('listTeamMembers', options);

/**
 * List Team Members
 */
export const listTeamMembersOptions = (options: Options<ListTeamMembersData>) =>
  queryOptions<
    ListTeamMembersResult,
    DefaultError,
    ListTeamMembersResult,
    ReturnType<typeof listTeamMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeamMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTeamMembersQueryKey(options),
  });

/**
 * Add Team Member
 */
export const addTeamMemberMutation = (
  options?: Partial<Options<AddTeamMemberData>>,
): UseMutationOptions<
  AddTeamMemberResult,
  DefaultError,
  Options<AddTeamMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    AddTeamMemberResult,
    DefaultError,
    Options<AddTeamMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Team Member Role
 */
export const updateTeamMemberRoleMutation = (
  options?: Partial<Options<UpdateTeamMemberRoleData>>,
): UseMutationOptions<
  UpdateTeamMemberRoleResult,
  DefaultError,
  Options<UpdateTeamMemberRoleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTeamMemberRoleResult,
    DefaultError,
    Options<UpdateTeamMemberRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTeamMemberRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove Team Member
 */
export const removeTeamMemberMutation = (
  options?: Partial<Options<RemoveTeamMemberData>>,
): UseMutationOptions<
  RemoveTeamMemberResult,
  DefaultError,
  Options<RemoveTeamMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveTeamMemberResult,
    DefaultError,
    Options<RemoveTeamMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSectionTimeLimitsQueryKey = (
  options?: Options<GetSectionTimeLimitsData>,
) => createQueryKey('getSectionTimeLimits', options);

/**
 * Get per-section duration limits
 *
 * Returns the duration floor, ceiling, default, and control mode for each section type. The frontend fetches this once per session to render the correct duration widget.
 */
export const getSectionTimeLimitsOptions = (
  options?: Options<GetSectionTimeLimitsData>,
) =>
  queryOptions<
    GetSectionTimeLimitsResponse,
    DefaultError,
    GetSectionTimeLimitsResponse,
    ReturnType<typeof getSectionTimeLimitsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSectionTimeLimits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSectionTimeLimitsQueryKey(options),
  });

export const listInterviewPlansQueryKey = (
  options: Options<ListInterviewPlansData>,
) => createQueryKey('listInterviewPlans', options);

/**
 * List interview plans for a job
 */
export const listInterviewPlansOptions = (
  options: Options<ListInterviewPlansData>,
) =>
  queryOptions<
    ListInterviewPlansResult,
    DefaultError,
    ListInterviewPlansResult,
    ReturnType<typeof listInterviewPlansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewPlans({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewPlansQueryKey(options),
  });

export const getInterviewPlanQueryKey = (
  options: Options<GetInterviewPlanData>,
) => createQueryKey('getInterviewPlan', options);

/**
 * Get an interview plan
 */
export const getInterviewPlanOptions = (
  options: Options<GetInterviewPlanData>,
) =>
  queryOptions<
    GetInterviewPlanResponse,
    DefaultError,
    GetInterviewPlanResponse,
    ReturnType<typeof getInterviewPlanQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlan({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanQueryKey(options),
  });

export const getCachedSectionsQueryKey = (
  options: Options<GetCachedSectionsData>,
) => createQueryKey('getCachedSections', options);

/**
 * Get cached section library for a job
 */
export const getCachedSectionsOptions = (
  options: Options<GetCachedSectionsData>,
) =>
  queryOptions<
    GetCachedSectionsResponse,
    DefaultError,
    GetCachedSectionsResponse,
    ReturnType<typeof getCachedSectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCachedSections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCachedSectionsQueryKey(options),
  });

export const getInterviewPlanRubricQueryKey = (
  options: Options<GetInterviewPlanRubricData>,
) => createQueryKey('getInterviewPlanRubric', options);

/**
 * Get the evaluation rubric for an interview plan
 *
 * Returns the stored rubric. Returns 404 if no rubric has been generated yet — call POST /interview-plans/rubric/generate to create one.
 */
export const getInterviewPlanRubricOptions = (
  options: Options<GetInterviewPlanRubricData>,
) =>
  queryOptions<
    GetInterviewPlanRubricResponse,
    DefaultError,
    GetInterviewPlanRubricResponse,
    ReturnType<typeof getInterviewPlanRubricQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlanRubric({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanRubricQueryKey(options),
  });

export const getInterviewPlanDraftQueryKey = (
  options: Options<GetInterviewPlanDraftData>,
) => createQueryKey('getInterviewPlanDraft', options);

/**
 * Get the planner wizard draft state for a job
 *
 * Returns wizard fields persisted on the Job row plus derived `current_step` and `is_locked`. Always returns 200 — empty/default values if the user hasn't started the wizard yet. `is_locked=true` once a plan exists for the job (draft becomes read-only).
 */
export const getInterviewPlanDraftOptions = (
  options: Options<GetInterviewPlanDraftData>,
) =>
  queryOptions<
    GetInterviewPlanDraftResponse,
    DefaultError,
    GetInterviewPlanDraftResponse,
    ReturnType<typeof getInterviewPlanDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewPlanDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewPlanDraftQueryKey(options),
  });

/**
 * Apply an operation to an interview plan
 *
 * Operation-based plan mutation. Supported operations: edit, add-section, remove-section, reorder-sections, regenerate, dismiss-stale, dismiss-all-stale. Returns the updated plan with plan_meta (duration budget, section limits). Returns 409 on version conflict, 404 if section not found.
 */
export const applyPlanOperationMutation = (
  options?: Partial<Options<ApplyPlanOperationData>>,
): UseMutationOptions<
  ApplyPlanOperationResult,
  DefaultError,
  Options<ApplyPlanOperationData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyPlanOperationResult,
    DefaultError,
    Options<ApplyPlanOperationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyPlanOperation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create an AI-generated interview plan
 *
 * Generates a complete interview plan using AI. May take up to 2 minutes.
 */
export const createInterviewPlanMutation = (
  options?: Partial<Options<CreateInterviewPlanData>>,
): UseMutationOptions<
  CreateInterviewPlanResponse,
  DefaultError,
  Options<CreateInterviewPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateInterviewPlanResponse,
    DefaultError,
    Options<CreateInterviewPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createInterviewPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate (or return existing) evaluation rubric for an interview plan
 *
 * Returns the existing rubric if present unless ``force_regenerate=true``. Otherwise calls the LLM to generate a new rubric, persists it to plan.params, and returns it. Generation can take 10–60s.
 */
export const generateInterviewPlanRubricMutation = (
  options?: Partial<Options<GenerateInterviewPlanRubricData>>,
): UseMutationOptions<
  GenerateInterviewPlanRubricResponse,
  DefaultError,
  Options<GenerateInterviewPlanRubricData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInterviewPlanRubricResponse,
    DefaultError,
    Options<GenerateInterviewPlanRubricData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInterviewPlanRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Manually replace the evaluation rubric for an interview plan
 *
 * Replaces the rubric on a plan with a hand-edited version. Criterion weights must sum to 1.0 (±0.01) — 422 otherwise.
 */
export const updateInterviewPlanRubricMutation = (
  options?: Partial<Options<UpdateInterviewPlanRubricData>>,
): UseMutationOptions<
  UpdateInterviewPlanRubricResponse,
  DefaultError,
  Options<UpdateInterviewPlanRubricData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateInterviewPlanRubricResponse,
    DefaultError,
    Options<UpdateInterviewPlanRubricData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateInterviewPlanRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save the planner wizard draft state for a job
 *
 * Idempotent full-state replacement of wizard fields on the Job row. Returns 409 if a plan already exists for the job (the draft is locked). Side effect: if Job.description is empty, the saved jd_text is mirrored into it — jobs created entirely through the wizard never went through POST /jobs.
 */
export const saveInterviewPlanDraftMutation = (
  options?: Partial<Options<SaveInterviewPlanDraftData>>,
): UseMutationOptions<
  SaveInterviewPlanDraftResponse,
  DefaultError,
  Options<SaveInterviewPlanDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveInterviewPlanDraftResponse,
    DefaultError,
    Options<SaveInterviewPlanDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveInterviewPlanDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Pass-through LLM call for the Question Generator sales-demo tool
 */
export const questionGeneratorLlmMutation = (
  options?: Partial<Options<QuestionGeneratorLlmData>>,
): UseMutationOptions<
  QuestionGeneratorLlmResponse,
  DefaultError,
  Options<QuestionGeneratorLlmData>
> => {
  const mutationOptions: UseMutationOptions<
    QuestionGeneratorLlmResponse,
    DefaultError,
    Options<QuestionGeneratorLlmData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await questionGeneratorLlm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPlannerSessionQueryKey = (
  options: Options<GetPlannerSessionData>,
) => createQueryKey('getPlannerSession', options);

/**
 * Read a planner session's status, gate payload, or result
 *
 * Read a session.
 */
export const getPlannerSessionOptions = (
  options: Options<GetPlannerSessionData>,
) =>
  queryOptions<
    GetPlannerSessionResponse,
    DefaultError,
    GetPlannerSessionResponse,
    ReturnType<typeof getPlannerSessionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlannerSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlannerSessionQueryKey(options),
  });

export const getPlannerTurnsQueryKey = (
  options: Options<GetPlannerTurnsData>,
) => createQueryKey('getPlannerTurns', options);

/**
 * Read a session's per-node turn log, including any failure's kind
 *
 * Read a session's turn log.
 */
export const getPlannerTurnsOptions = (options: Options<GetPlannerTurnsData>) =>
  queryOptions<
    GetPlannerTurnsResponse,
    DefaultError,
    GetPlannerTurnsResponse,
    ReturnType<typeof getPlannerTurnsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlannerTurns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlannerTurnsQueryKey(options),
  });

/**
 * Start a planner session for a job; drafting runs as a background job
 *
 * Start a session for a job.
 */
export const startPlannerSessionMutation = (
  options?: Partial<Options<StartPlannerSessionData>>,
): UseMutationOptions<
  StartPlannerSessionResult,
  DefaultError,
  Options<StartPlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    StartPlannerSessionResult,
    DefaultError,
    Options<StartPlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startPlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Seed a planner session from the job's stored plan and start the migrate chain
 *
 * Start a session from the job's stored plan.
 */
export const migratePlannerSessionMutation = (
  options?: Partial<Options<MigratePlannerSessionData>>,
): UseMutationOptions<
  MigratePlannerSessionResponse,
  DefaultError,
  Options<MigratePlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    MigratePlannerSessionResponse,
    DefaultError,
    Options<MigratePlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await migratePlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Answer the review gate (approve, refine, wrong_focus, abort)
 *
 * Answer the review gate.
 */
export const decidePlannerSessionMutation = (
  options?: Partial<Options<DecidePlannerSessionData>>,
): UseMutationOptions<
  DecidePlannerSessionResponse,
  DefaultError,
  Options<DecidePlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    DecidePlannerSessionResponse,
    DefaultError,
    Options<DecidePlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await decidePlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Apply structured high-level section edits; a changed section regenerates at the next compile
 *
 * Apply structured edits to the draft.
 */
export const editPlannerSessionMutation = (
  options?: Partial<Options<EditPlannerSessionData>>,
): UseMutationOptions<
  EditPlannerSessionResponse,
  DefaultError,
  Options<EditPlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    EditPlannerSessionResponse,
    DefaultError,
    Options<EditPlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await editPlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Re-enqueue a planner session whose background job was lost (idempotent)
 *
 * Re-enqueue an idle session's background job.
 */
export const resumePlannerSessionMutation = (
  options?: Partial<Options<ResumePlannerSessionData>>,
): UseMutationOptions<
  ResumePlannerSessionResponse,
  DefaultError,
  Options<ResumePlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    ResumePlannerSessionResponse,
    DefaultError,
    Options<ResumePlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resumePlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Persist the finished session's plan as a new interview plan for the job
 *
 * Save the finished plan as the job's interview plan.
 */
export const applyPlannerSessionMutation = (
  options?: Partial<Options<ApplyPlannerSessionData>>,
): UseMutationOptions<
  ApplyPlannerSessionResult,
  DefaultError,
  Options<ApplyPlannerSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyPlannerSessionResult,
    DefaultError,
    Options<ApplyPlannerSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyPlannerSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest interview topics for a section
 */
export const suggestTopicsMutation = (
  options?: Partial<Options<SuggestTopicsData>>,
): UseMutationOptions<
  SuggestTopicsResponse,
  DefaultError,
  Options<SuggestTopicsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestTopicsResponse,
    DefaultError,
    Options<SuggestTopicsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestTopics({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest subtopics for a topic
 */
export const suggestSubtopicsMutation = (
  options?: Partial<Options<SuggestSubtopicsData>>,
): UseMutationOptions<
  SuggestSubtopicsResponse,
  DefaultError,
  Options<SuggestSubtopicsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestSubtopicsResponse,
    DefaultError,
    Options<SuggestSubtopicsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestSubtopics({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest interview questions for a section
 */
export const suggestQuestionsMutation = (
  options?: Partial<Options<SuggestQuestionsData>>,
): UseMutationOptions<
  SuggestQuestionsResult,
  DefaultError,
  Options<SuggestQuestionsData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestQuestionsResult,
    DefaultError,
    Options<SuggestQuestionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestQuestions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regenerate case study content for a section
 */
export const regenerateCaseStudyMutation = (
  options?: Partial<Options<RegenerateCaseStudyData>>,
): UseMutationOptions<
  RegenerateCaseStudyResponse,
  DefaultError,
  Options<RegenerateCaseStudyData>
> => {
  const mutationOptions: UseMutationOptions<
    RegenerateCaseStudyResponse,
    DefaultError,
    Options<RegenerateCaseStudyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await regenerateCaseStudy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate a sample interactive coding problem
 */
export const generateInteractiveProblemMutation = (
  options?: Partial<Options<GenerateInteractiveProblemData>>,
): UseMutationOptions<
  GenerateInteractiveProblemResponse,
  DefaultError,
  Options<GenerateInteractiveProblemData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInteractiveProblemResponse,
    DefaultError,
    Options<GenerateInteractiveProblemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInteractiveProblem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Suggest values for interactive coding config fields
 */
export const suggestInteractiveConfigMutation = (
  options?: Partial<Options<SuggestInteractiveConfigData>>,
): UseMutationOptions<
  SuggestInteractiveConfigResponse,
  DefaultError,
  Options<SuggestInteractiveConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    SuggestInteractiveConfigResponse,
    DefaultError,
    Options<SuggestInteractiveConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suggestInteractiveConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate evaluation criteria for a section
 */
export const generateSectionCriteriaMutation = (
  options?: Partial<Options<GenerateSectionCriteriaData>>,
): UseMutationOptions<
  GenerateSectionCriteriaResponse,
  DefaultError,
  Options<GenerateSectionCriteriaData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSectionCriteriaResponse,
    DefaultError,
    Options<GenerateSectionCriteriaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateSectionCriteria({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Expand a draft job description into a complete one
 */
export const expandJobDescriptionMutation = (
  options?: Partial<Options<ExpandJobDescriptionData>>,
): UseMutationOptions<
  ExpandJobDescriptionResponse,
  DefaultError,
  Options<ExpandJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    ExpandJobDescriptionResponse,
    DefaultError,
    Options<ExpandJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await expandJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refine an existing job description based on user feedback
 */
export const refineJobDescriptionMutation = (
  options?: Partial<Options<RefineJobDescriptionData>>,
): UseMutationOptions<
  RefineJobDescriptionResponse,
  DefaultError,
  Options<RefineJobDescriptionData>
> => {
  const mutationOptions: UseMutationOptions<
    RefineJobDescriptionResponse,
    DefaultError,
    Options<RefineJobDescriptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refineJobDescription({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refine a selected portion of a job description
 */
export const refineJdSelectionMutation = (
  options?: Partial<Options<RefineJdSelectionData>>,
): UseMutationOptions<
  RefineJdSelectionResponse,
  DefaultError,
  Options<RefineJdSelectionData>
> => {
  const mutationOptions: UseMutationOptions<
    RefineJdSelectionResponse,
    DefaultError,
    Options<RefineJdSelectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refineJdSelection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSimulationPersonasQueryKey = (
  options?: Options<ListSimulationPersonasData>,
) => createQueryKey('listSimulationPersonas', options);

/**
 * List the canonical simulation personas
 */
export const listSimulationPersonasOptions = (
  options?: Options<ListSimulationPersonasData>,
) =>
  queryOptions<
    ListSimulationPersonasResponse,
    DefaultError,
    ListSimulationPersonasResponse,
    ReturnType<typeof listSimulationPersonasQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSimulationPersonas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSimulationPersonasQueryKey(options),
  });

export const getSimulationPersonaQueryKey = (
  options: Options<GetSimulationPersonaData>,
) => createQueryKey('getSimulationPersona', options);

/**
 * Read one canonical persona, including the character prompt it renders
 */
export const getSimulationPersonaOptions = (
  options: Options<GetSimulationPersonaData>,
) =>
  queryOptions<
    GetSimulationPersonaResponse,
    GetSimulationPersonaError,
    GetSimulationPersonaResponse,
    ReturnType<typeof getSimulationPersonaQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSimulationPersona({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSimulationPersonaQueryKey(options),
  });

/**
 * Prepare a persona for a plan: the snapshot a run plays, its hashes, and the skill mapping
 *
 * The slow half of starting a run, and the step `POST /simulations` requires. Resolving a pairing for the first time is two model calls; this writes only caches, so an abandoned prepare creates no application, interview or run. Start with the `instance_hash` it returns.
 */
export const resolveSimulationPersonaMutation = (
  options?: Partial<Options<ResolveSimulationPersonaData>>,
): UseMutationOptions<
  ResolveSimulationPersonaResponse,
  ResolveSimulationPersonaError,
  Options<ResolveSimulationPersonaData>
> => {
  const mutationOptions: UseMutationOptions<
    ResolveSimulationPersonaResponse,
    ResolveSimulationPersonaError,
    Options<ResolveSimulationPersonaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resolveSimulationPersona({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Check an interview against a persona's expectations
 */
export const checkSimulationAssertionsMutation = (
  options?: Partial<Options<CheckSimulationAssertionsData>>,
): UseMutationOptions<
  CheckSimulationAssertionsResponse,
  CheckSimulationAssertionsError,
  Options<CheckSimulationAssertionsData>
> => {
  const mutationOptions: UseMutationOptions<
    CheckSimulationAssertionsResponse,
    CheckSimulationAssertionsError,
    Options<CheckSimulationAssertionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkSimulationAssertions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Judge a finished run again on the evidence it already has
 *
 * The same check the completion hook runs, on a run that has already been judged, replacing its verdict. Nothing is re-derived: the persona, the skill mapping and the transcript are the ones the run played. Pass `apparatus` to re-pin the judges first, which is how a change to a judge is shown to be an improvement rather than a difference.
 */
export const recheckSimulationMutation = (
  options?: Partial<Options<RecheckSimulationData>>,
): UseMutationOptions<
  RecheckSimulationResult,
  RecheckSimulationError,
  Options<RecheckSimulationData>
> => {
  const mutationOptions: UseMutationOptions<
    RecheckSimulationResult,
    RecheckSimulationError,
    Options<RecheckSimulationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recheckSimulation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSimulationsQueryKey = (
  options: Options<ListSimulationsData>,
) => createQueryKey('listSimulations', options);

/**
 * List the simulation runs on a job
 */
export const listSimulationsOptions = (options: Options<ListSimulationsData>) =>
  queryOptions<
    ListSimulationsResult,
    ListSimulationsError,
    ListSimulationsResult,
    ReturnType<typeof listSimulationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSimulations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSimulationsQueryKey(options),
  });

/**
 * Run a prepared persona against a plan: creates the candidate, the interview, and dispatches the runner
 *
 * Requires a pairing already prepared by `POST /simulations/personas/resolve`, and the `instance_hash` that call returned. A pairing that has never been prepared is a 409 rather than a two-minute wait, and creates nothing.
 */
export const startSimulationMutation = (
  options?: Partial<Options<StartSimulationData>>,
): UseMutationOptions<
  StartSimulationResult,
  StartSimulationError,
  Options<StartSimulationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartSimulationResult,
    StartSimulationError,
    Options<StartSimulationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startSimulation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSimulationTranscriptQueryKey = (
  options: Options<GetSimulationTranscriptData>,
) => createQueryKey('getSimulationTranscript', options);

/**
 * The conversation so far and how far through the run is
 *
 * Built for polling while a run is going: the transcript sections and the progress, and nothing else. Before the first events land it returns an empty transcript rather than a 404, which is the run starting rather than an error.
 */
export const getSimulationTranscriptOptions = (
  options: Options<GetSimulationTranscriptData>,
) =>
  queryOptions<
    GetSimulationTranscriptResponse,
    GetSimulationTranscriptError,
    GetSimulationTranscriptResponse,
    ReturnType<typeof getSimulationTranscriptQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSimulationTranscript({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSimulationTranscriptQueryKey(options),
  });

export const getSimulationQueryKey = (options: Options<GetSimulationData>) =>
  createQueryKey('getSimulation', options);

/**
 * Status, progress through the interview, and assertion results once they exist
 */
export const getSimulationOptions = (options: Options<GetSimulationData>) =>
  queryOptions<
    GetSimulationResponse,
    GetSimulationError,
    GetSimulationResponse,
    ReturnType<typeof getSimulationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSimulation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSimulationQueryKey(options),
  });

/**
 * Draft an editable persona from an uploaded resume
 */
export const generateSimulationPersonaMutation = (
  options?: Partial<Options<GenerateSimulationPersonaData>>,
): UseMutationOptions<
  GenerateSimulationPersonaResponse,
  GenerateSimulationPersonaError,
  Options<GenerateSimulationPersonaData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSimulationPersonaResponse,
    GenerateSimulationPersonaError,
    Options<GenerateSimulationPersonaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateSimulationPersona({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getScreenerPlanQueryKey = (
  options: Options<GetScreenerPlanData>,
) => createQueryKey('getScreenerPlan', options);

/**
 * Get the active screener plan for a job
 */
export const getScreenerPlanOptions = (options: Options<GetScreenerPlanData>) =>
  queryOptions<
    GetScreenerPlanResponse,
    DefaultError,
    GetScreenerPlanResponse,
    ReturnType<typeof getScreenerPlanQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreenerPlan({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreenerPlanQueryKey(options),
  });

export const exportScreenerPlansQueryKey = (
  options: Options<ExportScreenerPlansData>,
) => createQueryKey('exportScreenerPlans', options);

/**
 * Export all screener plan versions and their scores
 */
export const exportScreenerPlansOptions = (
  options: Options<ExportScreenerPlansData>,
) =>
  queryOptions<
    ExportScreenerPlansResponse,
    DefaultError,
    ExportScreenerPlansResponse,
    ReturnType<typeof exportScreenerPlansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportScreenerPlans({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exportScreenerPlansQueryKey(options),
  });

export const getPublicScreenerApplicationQueryKey = (
  options: Options<GetPublicScreenerApplicationData>,
) => createQueryKey('getPublicScreenerApplication', options);

/**
 * Get Public Screener Application
 */
export const getPublicScreenerApplicationOptions = (
  options: Options<GetPublicScreenerApplicationData>,
) =>
  queryOptions<
    GetPublicScreenerApplicationResponse,
    DefaultError,
    GetPublicScreenerApplicationResponse,
    ReturnType<typeof getPublicScreenerApplicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicScreenerApplication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicScreenerApplicationQueryKey(options),
  });

export const getScreeningApplicationsQueryKey = (
  options: Options<GetScreeningApplicationsData>,
) => createQueryKey('getScreeningApplications', options);

/**
 * List applications + their screener results for a job
 */
export const getScreeningApplicationsOptions = (
  options: Options<GetScreeningApplicationsData>,
) =>
  queryOptions<
    GetScreeningApplicationsResponse,
    DefaultError,
    GetScreeningApplicationsResponse,
    ReturnType<typeof getScreeningApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreeningApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreeningApplicationsQueryKey(options),
  });

export const getScreeningApplicationsInfiniteQueryKey = (
  options: Options<GetScreeningApplicationsData>,
): QueryKey<Options<GetScreeningApplicationsData>> =>
  createQueryKey('getScreeningApplications', options, true);

/**
 * List applications + their screener results for a job
 */
export const getScreeningApplicationsInfiniteOptions = (
  options: Options<GetScreeningApplicationsData>,
) =>
  infiniteQueryOptions<
    GetScreeningApplicationsResponse,
    DefaultError,
    InfiniteData<GetScreeningApplicationsResponse>,
    QueryKey<Options<GetScreeningApplicationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetScreeningApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetScreeningApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getScreeningApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getScreeningApplicationsInfiniteQueryKey(options),
    },
  );

export const getScreeningApplicationQueryKey = (
  options: Options<GetScreeningApplicationData>,
) => createQueryKey('getScreeningApplication', options);

/**
 * Get one screening application with all rubric results
 */
export const getScreeningApplicationOptions = (
  options: Options<GetScreeningApplicationData>,
) =>
  queryOptions<
    GetScreeningApplicationResponse,
    DefaultError,
    GetScreeningApplicationResponse,
    ReturnType<typeof getScreeningApplicationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScreeningApplication({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScreeningApplicationQueryKey(options),
  });

export const getJobApplicationQuestionsQueryKey = (
  options: Options<GetJobApplicationQuestionsData>,
) => createQueryKey('getJobApplicationQuestions', options);

/**
 * The job's active application questions (with options), read-only for the design page
 */
export const getJobApplicationQuestionsOptions = (
  options: Options<GetJobApplicationQuestionsData>,
) =>
  queryOptions<
    GetJobApplicationQuestionsResponse,
    DefaultError,
    GetJobApplicationQuestionsResponse,
    ReturnType<typeof getJobApplicationQuestionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobApplicationQuestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobApplicationQuestionsQueryKey(options),
  });

/**
 * Generate Screener Share Token
 */
export const generateScreenerShareTokenMutation = (
  options?: Partial<Options<GenerateScreenerShareTokenData>>,
): UseMutationOptions<
  GenerateScreenerShareTokenResponse,
  DefaultError,
  Options<GenerateScreenerShareTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateScreenerShareTokenResponse,
    DefaultError,
    Options<GenerateScreenerShareTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateScreenerShareToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate a fresh screener plan for a job (LLM-driven)
 */
export const createScreenerPlanMutation = (
  options?: Partial<Options<CreateScreenerPlanData>>,
): UseMutationOptions<
  CreateScreenerPlanResponse,
  DefaultError,
  Options<CreateScreenerPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateScreenerPlanResponse,
    DefaultError,
    Options<CreateScreenerPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createScreenerPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * In-place update of an active screener plan. Wipes Screening rows for re-evaluation.
 */
export const updateScreenerPlanMutation = (
  options?: Partial<Options<UpdateScreenerPlanData>>,
): UseMutationOptions<
  UpdateScreenerPlanResponse,
  DefaultError,
  Options<UpdateScreenerPlanData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateScreenerPlanResponse,
    DefaultError,
    Options<UpdateScreenerPlanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateScreenerPlan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Fan out evaluation tasks across every application on the job
 */
export const evaluateScreenerJobMutation = (
  options?: Partial<Options<EvaluateScreenerJobData>>,
): UseMutationOptions<
  EvaluateScreenerJobResponse,
  DefaultError,
  Options<EvaluateScreenerJobData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateScreenerJobResponse,
    DefaultError,
    Options<EvaluateScreenerJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateScreenerJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Trigger evaluation for a single application
 */
export const evaluateScreenerApplicationMutation = (
  options?: Partial<Options<EvaluateScreenerApplicationData>>,
): UseMutationOptions<
  EvaluateScreenerApplicationResponse,
  DefaultError,
  Options<EvaluateScreenerApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateScreenerApplicationResponse,
    DefaultError,
    Options<EvaluateScreenerApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateScreenerApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add an application question to a job
 */
export const createApplicationQuestionMutation = (
  options?: Partial<Options<CreateApplicationQuestionData>>,
): UseMutationOptions<
  CreateApplicationQuestionResponse,
  DefaultError,
  Options<CreateApplicationQuestionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateApplicationQuestionResponse,
    DefaultError,
    Options<CreateApplicationQuestionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createApplicationQuestion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save changes to a job's application question
 */
export const updateApplicationQuestionMutation = (
  options?: Partial<Options<UpdateApplicationQuestionData>>,
): UseMutationOptions<
  UpdateApplicationQuestionResponse,
  DefaultError,
  Options<UpdateApplicationQuestionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateApplicationQuestionResponse,
    DefaultError,
    Options<UpdateApplicationQuestionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateApplicationQuestion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a job's application question, or hide it once candidates answered it
 */
export const deleteApplicationQuestionMutation = (
  options?: Partial<Options<DeleteApplicationQuestionData>>,
): UseMutationOptions<
  DeleteApplicationQuestionResult,
  DefaultError,
  Options<DeleteApplicationQuestionData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApplicationQuestionResult,
    DefaultError,
    Options<DeleteApplicationQuestionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteApplicationQuestion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPrescreenConversationQueryKey = (
  options: Options<GetPrescreenConversationData>,
) => createQueryKey('getPrescreenConversation', options);

/**
 * Get the candidate's prescreen conversation, or null when the job has none
 */
export const getPrescreenConversationOptions = (
  options: Options<GetPrescreenConversationData>,
) =>
  queryOptions<
    GetPrescreenConversationResponse,
    DefaultError,
    GetPrescreenConversationResponse,
    ReturnType<typeof getPrescreenConversationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationQueryKey(options),
  });

/**
 * Start Conversation
 */
export const startPrescreenConversationMutation = (
  options?: Partial<Options<StartPrescreenConversationData>>,
): UseMutationOptions<
  StartPrescreenConversationResponse,
  DefaultError,
  Options<StartPrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartPrescreenConversationResponse,
    DefaultError,
    Options<StartPrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startPrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete Conversation
 */
export const completePrescreenConversationMutation = (
  options?: Partial<Options<CompletePrescreenConversationData>>,
): UseMutationOptions<
  CompletePrescreenConversationResponse,
  DefaultError,
  Options<CompletePrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    CompletePrescreenConversationResponse,
    DefaultError,
    Options<CompletePrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completePrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPrescreenConversationDetailQueryKey = (
  options: Options<GetPrescreenConversationDetailData>,
) => createQueryKey('getPrescreenConversationDetail', options);

/**
 * Get the full conversation with transcript (recruiter)
 */
export const getPrescreenConversationDetailOptions = (
  options: Options<GetPrescreenConversationDetailData>,
) =>
  queryOptions<
    GetPrescreenConversationDetailResponse,
    DefaultError,
    GetPrescreenConversationDetailResponse,
    ReturnType<typeof getPrescreenConversationDetailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversationDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationDetailQueryKey(options),
  });

export const getPrescreenConversationsQueryKey = (
  options: Options<GetPrescreenConversationsData>,
) => createQueryKey('getPrescreenConversations', options);

/**
 * Conversation status for every application on a job (recruiter)
 */
export const getPrescreenConversationsOptions = (
  options: Options<GetPrescreenConversationsData>,
) =>
  queryOptions<
    GetPrescreenConversationsResponse,
    DefaultError,
    GetPrescreenConversationsResponse,
    ReturnType<typeof getPrescreenConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrescreenConversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrescreenConversationsQueryKey(options),
  });

/**
 * Stop waiting on the candidate and screen them now (recruiter)
 */
export const forceReleasePrescreenConversationMutation = (
  options?: Partial<Options<ForceReleasePrescreenConversationData>>,
): UseMutationOptions<
  ForceReleasePrescreenConversationResponse,
  DefaultError,
  Options<ForceReleasePrescreenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    ForceReleasePrescreenConversationResponse,
    DefaultError,
    Options<ForceReleasePrescreenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await forceReleasePrescreenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPublicJobsQueryKey = (options?: Options<ListPublicJobsData>) =>
  createQueryKey('listPublicJobs', options);

/**
 * List published jobs (public)
 */
export const listPublicJobsOptions = (options?: Options<ListPublicJobsData>) =>
  queryOptions<
    ListPublicJobsResult,
    DefaultError,
    ListPublicJobsResult,
    ReturnType<typeof listPublicJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPublicJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPublicJobsQueryKey(options),
  });

export const getPublicJobQueryKey = (options: Options<GetPublicJobData>) =>
  createQueryKey('getPublicJob', options);

/**
 * Get a published job (public)
 */
export const getPublicJobOptions = (options: Options<GetPublicJobData>) =>
  queryOptions<
    GetPublicJobResponse,
    DefaultError,
    GetPublicJobResponse,
    ReturnType<typeof getPublicJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicJobQueryKey(options),
  });

export const getJobLoginContextQueryKey = (
  options: Options<GetJobLoginContextData>,
) => createQueryKey('getJobLoginContext', options);

/**
 * Minimal pre-auth login-screen context for a job (works for unpublished invite-only jobs)
 */
export const getJobLoginContextOptions = (
  options: Options<GetJobLoginContextData>,
) =>
  queryOptions<
    GetJobLoginContextResponse,
    DefaultError,
    GetJobLoginContextResponse,
    ReturnType<typeof getJobLoginContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobLoginContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobLoginContextQueryKey(options),
  });

export const listMyJobsQueryKey = (options?: Options<ListMyJobsData>) =>
  createQueryKey('listMyJobs', options);

/**
 * List published jobs with candidate annotations (authenticated)
 */
export const listMyJobsOptions = (options?: Options<ListMyJobsData>) =>
  queryOptions<
    ListMyJobsResult,
    DefaultError,
    ListMyJobsResult,
    ReturnType<typeof listMyJobsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyJobs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyJobsQueryKey(options),
  });

export const getMyJobQueryKey = (options: Options<GetMyJobData>) =>
  createQueryKey('getMyJob', options);

/**
 * Get a published job with full candidate detail (authenticated)
 */
export const getMyJobOptions = (options: Options<GetMyJobData>) =>
  queryOptions<
    GetMyJobResponse,
    DefaultError,
    GetMyJobResponse,
    ReturnType<typeof getMyJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyJobQueryKey(options),
  });

export const getApplicationQuestionsQueryKey = (
  options: Options<GetApplicationQuestionsData>,
) => createQueryKey('getApplicationQuestions', options);

/**
 * Get custom application questions and own answers for a job (authenticated)
 */
export const getApplicationQuestionsOptions = (
  options: Options<GetApplicationQuestionsData>,
) =>
  queryOptions<
    GetApplicationQuestionsResponse,
    DefaultError,
    GetApplicationQuestionsResponse,
    ReturnType<typeof getApplicationQuestionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApplicationQuestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApplicationQuestionsQueryKey(options),
  });

/**
 * Submit answers to a job's custom application questions (candidate)
 */
export const submitApplicationAnswersMutation = (
  options?: Partial<Options<SubmitApplicationAnswersData>>,
): UseMutationOptions<
  SubmitApplicationAnswersResponse,
  DefaultError,
  Options<SubmitApplicationAnswersData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitApplicationAnswersResponse,
    DefaultError,
    Options<SubmitApplicationAnswersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitApplicationAnswers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete own application (candidate)
 */
export const deleteApplicationCandidateMutation = (
  options?: Partial<Options<DeleteApplicationCandidateData>>,
): UseMutationOptions<
  DeleteApplicationCandidateResponse,
  DefaultError,
  Options<DeleteApplicationCandidateData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApplicationCandidateResponse,
    DefaultError,
    Options<DeleteApplicationCandidateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteApplicationCandidate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Accept privacy policy for own application (candidate)
 */
export const acceptPrivacyPolicyMutation = (
  options?: Partial<Options<AcceptPrivacyPolicyData>>,
): UseMutationOptions<
  AcceptPrivacyPolicyResponse,
  DefaultError,
  Options<AcceptPrivacyPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptPrivacyPolicyResponse,
    DefaultError,
    Options<AcceptPrivacyPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptPrivacyPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Apply for a job — optional multipart resume upload
 */
export const applyForJobMutation = (
  options?: Partial<Options<ApplyForJobData>>,
): UseMutationOptions<
  ApplyForJobResult,
  DefaultError,
  Options<ApplyForJobData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyForJobResult,
    DefaultError,
    Options<ApplyForJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyForJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a resume for an existing application (multipart)
 */
export const uploadResumeForApplicationMutation = (
  options?: Partial<Options<UploadResumeForApplicationData>>,
): UseMutationOptions<
  UploadResumeForApplicationResponse,
  DefaultError,
  Options<UploadResumeForApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadResumeForApplicationResponse,
    DefaultError,
    Options<UploadResumeForApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadResumeForApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCandidateInterviewQueryKey = (
  options: Options<GetCandidateInterviewData>,
) => createQueryKey('getCandidateInterview', options);

/**
 * Get interview details for the candidate taking the interview
 *
 * Returns the meeting-critical interview payload for the authenticated candidate. Fails with 403 if the authenticated user does not own this interview. Includes a 2-hour signed GCS URL for the candidate's resume.
 */
export const getCandidateInterviewOptions = (
  options: Options<GetCandidateInterviewData>,
) =>
  queryOptions<
    GetCandidateInterviewResponse,
    DefaultError,
    GetCandidateInterviewResponse,
    ReturnType<typeof getCandidateInterviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateInterview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateInterviewQueryKey(options),
  });

/**
 * Send one message to the case study chat assistant
 *
 * Streams the assistant's reply as plain text, a fragment at a time. Fails with 403 if the authenticated user does not own this interview, and with 429 once the per-user rate limit is hit. Both sides of the turn are recorded before and after the model call, so the transcript survives a dropped request.
 */
export const sendCaseStudyChatMessageMutation = (
  options?: Partial<Options<SendCaseStudyChatMessageData>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<SendCaseStudyChatMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<SendCaseStudyChatMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendCaseStudyChatMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Log a batch of camera-bitrate readings for the connection-quality feature
 *
 * Logs bitrate readings to BigQuery only, REC-2321 PR1 makes no pause or kick decision from this data yet. Fails with 403 if the authenticated user does not own this interview, and with 429 once the per-user rate limit is hit. A dropped write never affects the interview, telemetry is fail-open.
 */
export const recordConnectionQualityMutation = (
  options?: Partial<Options<RecordConnectionQualityData>>,
): UseMutationOptions<
  RecordConnectionQualityResult,
  DefaultError,
  Options<RecordConnectionQualityData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordConnectionQualityResult,
    DefaultError,
    Options<RecordConnectionQualityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordConnectionQuality({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listMyInterviewsQueryKey = (
  options?: Options<ListMyInterviewsData>,
) => createQueryKey('listMyInterviews', options);

/**
 * List all interviews for the authenticated candidate
 *
 * Returns all interviews belonging to the authenticated user across all tenants. Pass ?lockdown_browser_only=true to restrict to jobs with lockdown browser enabled (used by the desktop client). This query is intentionally cross-tenant: the desktop lockdown browser authenticates via the central auth subdomain, not the candidate's employer subdomain, so tenant filtering would silently return empty results for those clients.
 */
export const listMyInterviewsOptions = (
  options?: Options<ListMyInterviewsData>,
) =>
  queryOptions<
    ListMyInterviewsResult,
    DefaultError,
    ListMyInterviewsResult,
    ReturnType<typeof listMyInterviewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyInterviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyInterviewsQueryKey(options),
  });

export const getRecruiterInterviewQueryKey = (
  options: Options<GetRecruiterInterviewData>,
) => createQueryKey('getRecruiterInterview', options);

/**
 * Get interview details for a recruiter
 *
 * Returns the full interview detail for a recruiter, including candidate PII, the synthesized scorecard (criteria mapped from TOML evaluation_criteria), and a 2-hour signed GCS URL for the candidate's resume. Fails with 403 if the caller is not a tenant member.
 */
export const getRecruiterInterviewOptions = (
  options: Options<GetRecruiterInterviewData>,
) =>
  queryOptions<
    GetRecruiterInterviewResponse,
    DefaultError,
    GetRecruiterInterviewResponse,
    ReturnType<typeof getRecruiterInterviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecruiterInterview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRecruiterInterviewQueryKey(options),
  });

export const listInterviewsForJobQueryKey = (
  options: Options<ListInterviewsForJobData>,
) => createQueryKey('listInterviewsForJob', options);

/**
 * List interviews for a job (recruiter view)
 *
 * Returns a cursor-paginated list of interviews for the given job. Requires recruiter, hiring_manager, or Account Admin role. Pass ?tab= to filter by evaluation state. Pass ?intake_filters[batch]=<value> to filter by the batch field in intake metadata.
 */
export const listInterviewsForJobOptions = (
  options: Options<ListInterviewsForJobData>,
) =>
  queryOptions<
    ListInterviewsForJobResponse,
    DefaultError,
    ListInterviewsForJobResponse,
    ReturnType<typeof listInterviewsForJobQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listInterviewsForJob({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listInterviewsForJobQueryKey(options),
  });

export const listInterviewsForJobInfiniteQueryKey = (
  options: Options<ListInterviewsForJobData>,
): QueryKey<Options<ListInterviewsForJobData>> =>
  createQueryKey('listInterviewsForJob', options, true);

/**
 * List interviews for a job (recruiter view)
 *
 * Returns a cursor-paginated list of interviews for the given job. Requires recruiter, hiring_manager, or Account Admin role. Pass ?tab= to filter by evaluation state. Pass ?intake_filters[batch]=<value> to filter by the batch field in intake metadata.
 */
export const listInterviewsForJobInfiniteOptions = (
  options: Options<ListInterviewsForJobData>,
) =>
  infiniteQueryOptions<
    ListInterviewsForJobResponse,
    DefaultError,
    InfiniteData<ListInterviewsForJobResponse>,
    QueryKey<Options<ListInterviewsForJobData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListInterviewsForJobData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListInterviewsForJobData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInterviewsForJob({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listInterviewsForJobInfiniteQueryKey(options),
    },
  );

export const getInterviewResultQueryKey = (
  options?: Options<GetInterviewResultData>,
) => createQueryKey('getInterviewResult', options);

/**
 * Get interview result (session auth or share token)
 *
 * Two mutually exclusive access modes: pass `interview_id` for session-authenticated access (recruiter or candidate), or pass `token` for public share-link access. Exactly one must be provided.
 */
export const getInterviewResultOptions = (
  options?: Options<GetInterviewResultData>,
) =>
  queryOptions<
    GetInterviewResultResponse,
    DefaultError,
    GetInterviewResultResponse,
    ReturnType<typeof getInterviewResultQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInterviewResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInterviewResultQueryKey(options),
  });

export const getProctoringClipUrlQueryKey = (
  options: Options<GetProctoringClipUrlData>,
) => createQueryKey('getProctoringClipUrl', options);

/**
 * Sign one proctoring clip URL on demand (session auth or share token)
 *
 * Returns a short-lived signed URL for a single proctoring clip, signed on demand when the clip modal opens (clips are no longer signed at result-assembly time). Same access modes as get_interview_result: `interview_id`/`application_id` for session auth, or `token` for a public share link. A clip withheld from the result payload (disputed on a public share, or proctoring hidden) returns `clip_url=null`, as does a missing clip.
 */
export const getProctoringClipUrlOptions = (
  options: Options<GetProctoringClipUrlData>,
) =>
  queryOptions<
    GetProctoringClipUrlResponse,
    DefaultError,
    GetProctoringClipUrlResponse,
    ReturnType<typeof getProctoringClipUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProctoringClipUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProctoringClipUrlQueryKey(options),
  });

/**
 * Generate a public share link for an interview result
 */
export const generateInterviewShareTokenMutation = (
  options?: Partial<Options<GenerateInterviewShareTokenData>>,
): UseMutationOptions<
  GenerateInterviewShareTokenResponse,
  DefaultError,
  Options<GenerateInterviewShareTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateInterviewShareTokenResponse,
    DefaultError,
    Options<GenerateInterviewShareTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateInterviewShareToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Recruiter records feedback on a proctoring flag (agree or disagree) and re-buckets the candidate
 */
export const recordProctoringFeedbackMutation = (
  options?: Partial<Options<RecordProctoringFeedbackData>>,
): UseMutationOptions<
  RecordProctoringFeedbackResult,
  DefaultError,
  Options<RecordProctoringFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordProctoringFeedbackResult,
    DefaultError,
    Options<RecordProctoringFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordProctoringFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const greenhouseListTestsQueryKey = (
  options?: Options<GreenhouseListTestsData>,
) => createQueryKey('greenhouseListTests', options);

/**
 * List available tests (jobs) for Greenhouse
 *
 * Returns active jobs as partner tests. Authentication: HMAC Basic Auth.
 */
export const greenhouseListTestsOptions = (
  options?: Options<GreenhouseListTestsData>,
) =>
  queryOptions<
    GreenhouseListTestsResponse,
    DefaultError,
    GreenhouseListTestsResponse,
    ReturnType<typeof greenhouseListTestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await greenhouseListTests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: greenhouseListTestsQueryKey(options),
  });

export const greenhouseTestStatusQueryKey = (
  options: Options<GreenhouseTestStatusData>,
) => createQueryKey('greenhouseTestStatus', options);

/**
 * Get interview status
 *
 * Returns partner status and results for a given interview ID. Greenhouse polls this.
 */
export const greenhouseTestStatusOptions = (
  options: Options<GreenhouseTestStatusData>,
) =>
  queryOptions<
    GreenhouseTestStatusResponse,
    DefaultError,
    GreenhouseTestStatusResponse,
    ReturnType<typeof greenhouseTestStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await greenhouseTestStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: greenhouseTestStatusQueryKey(options),
  });

/**
 * Send candidate to assessment
 *
 * Creates user, application, and interview for a Greenhouse candidate. Queues invitation email.
 */
export const greenhouseSendTestMutation = (
  options?: Partial<Options<GreenhouseSendTestData>>,
): UseMutationOptions<
  GreenhouseSendTestResponse,
  DefaultError,
  Options<GreenhouseSendTestData>
> => {
  const mutationOptions: UseMutationOptions<
    GreenhouseSendTestResponse,
    DefaultError,
    Options<GreenhouseSendTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await greenhouseSendTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Log errors from Greenhouse
 *
 * Receives error reports from Greenhouse. Logs and returns 200.
 */
export const greenhouseRequestErrorsMutation = (
  options?: Partial<Options<GreenhouseRequestErrorsData>>,
): UseMutationOptions<
  GreenhouseRequestErrorsResponse,
  DefaultError,
  Options<GreenhouseRequestErrorsData>
> => {
  const mutationOptions: UseMutationOptions<
    GreenhouseRequestErrorsResponse,
    DefaultError,
    Options<GreenhouseRequestErrorsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await greenhouseRequestErrors({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Read-only: which of the supplied emails already have an active interview for this job
 */
export const checkAlreadyInSystemMutation = (
  options?: Partial<Options<CheckAlreadyInSystemData>>,
): UseMutationOptions<
  CheckAlreadyInSystemResult,
  DefaultError,
  Options<CheckAlreadyInSystemData>
> => {
  const mutationOptions: UseMutationOptions<
    CheckAlreadyInSystemResult,
    DefaultError,
    Options<CheckAlreadyInSystemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkAlreadyInSystem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCandidateIntakeValidationStatusQueryKey = (
  options: Options<GetCandidateIntakeValidationStatusData>,
) => createQueryKey('getCandidateIntakeValidationStatus', options);

/**
 * Poll status + progress of an in-flight or completed validation task
 */
export const getCandidateIntakeValidationStatusOptions = (
  options: Options<GetCandidateIntakeValidationStatusData>,
) =>
  queryOptions<
    GetCandidateIntakeValidationStatusResponse,
    DefaultError,
    GetCandidateIntakeValidationStatusResponse,
    ReturnType<typeof getCandidateIntakeValidationStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateIntakeValidationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateIntakeValidationStatusQueryKey(options),
  });

/**
 * Bulk-create screening-stage applications for a job
 */
export const bulkScreeningIntakeMutation = (
  options?: Partial<Options<BulkScreeningIntakeData>>,
): UseMutationOptions<
  BulkScreeningIntakeResult,
  DefaultError,
  Options<BulkScreeningIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkScreeningIntakeResult,
    DefaultError,
    Options<BulkScreeningIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkScreeningIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk-create interview-stage applications + Interview rows for a job
 */
export const bulkInterviewIntakeMutation = (
  options?: Partial<Options<BulkInterviewIntakeData>>,
): UseMutationOptions<
  BulkInterviewIntakeResult,
  DefaultError,
  Options<BulkInterviewIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkInterviewIntakeResult,
    DefaultError,
    Options<BulkInterviewIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkInterviewIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Move RESUME_SCREENING applications to INTERVIEWING and optionally fire invite emails
 */
export const inviteToInterviewMutation = (
  options?: Partial<Options<InviteToInterviewData>>,
): UseMutationOptions<
  InviteToInterviewResult,
  DefaultError,
  Options<InviteToInterviewData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteToInterviewResult,
    DefaultError,
    Options<InviteToInterviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteToInterview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Move CREATED applications to INVITED_FOR_ASSESSMENT and optionally fire invite emails
 */
export const inviteToAssessmentMutation = (
  options?: Partial<Options<InviteToAssessmentData>>,
): UseMutationOptions<
  InviteToAssessmentResult,
  DefaultError,
  Options<InviteToAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteToAssessmentResult,
    DefaultError,
    Options<InviteToAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteToAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk-create assessment-stage applications for a job (create + invite, skipping screening)
 */
export const bulkAssessmentIntakeMutation = (
  options?: Partial<Options<BulkAssessmentIntakeData>>,
): UseMutationOptions<
  BulkAssessmentIntakeResult,
  DefaultError,
  Options<BulkAssessmentIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkAssessmentIntakeResult,
    DefaultError,
    Options<BulkAssessmentIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkAssessmentIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one screening-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleScreeningIntakeMutation = (
  options?: Partial<Options<SingleScreeningIntakeData>>,
): UseMutationOptions<
  SingleScreeningIntakeResult,
  DefaultError,
  Options<SingleScreeningIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleScreeningIntakeResult,
    DefaultError,
    Options<SingleScreeningIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleScreeningIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one interview-stage application + Interview row for a job (multipart: request JSON + optional resume file)
 */
export const singleInterviewIntakeMutation = (
  options?: Partial<Options<SingleInterviewIntakeData>>,
): UseMutationOptions<
  SingleInterviewIntakeResult,
  DefaultError,
  Options<SingleInterviewIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleInterviewIntakeResult,
    DefaultError,
    Options<SingleInterviewIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleInterviewIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one assessment-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleAssessmentIntakeMutation = (
  options?: Partial<Options<SingleAssessmentIntakeData>>,
): UseMutationOptions<
  SingleAssessmentIntakeResult,
  DefaultError,
  Options<SingleAssessmentIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleAssessmentIntakeResult,
    DefaultError,
    Options<SingleAssessmentIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleAssessmentIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create one candidate and add them to the job's copilot round (multipart: request JSON + resume file, required unless one is on file)
 */
export const singleCopilotIntakeMutation = (
  options?: Partial<Options<SingleCopilotIntakeData>>,
): UseMutationOptions<
  SingleCopilotIntakeResult,
  DefaultError,
  Options<SingleCopilotIntakeData>
> => {
  const mutationOptions: UseMutationOptions<
    SingleCopilotIntakeResult,
    DefaultError,
    Options<SingleCopilotIntakeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await singleCopilotIntake({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kick off async validation of a candidate-intake spreadsheet or resume ZIP
 */
export const startCandidateIntakeValidationMutation = (
  options?: Partial<Options<StartCandidateIntakeValidationData>>,
): UseMutationOptions<
  StartCandidateIntakeValidationResponse,
  DefaultError,
  Options<StartCandidateIntakeValidationData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCandidateIntakeValidationResponse,
    DefaultError,
    Options<StartCandidateIntakeValidationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCandidateIntakeValidation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Parse a single PDF/DOCX resume into structured candidate fields
 */
export const parseCandidateResumeMutation = (
  options?: Partial<Options<ParseCandidateResumeData>>,
): UseMutationOptions<
  ParseCandidateResumeResponse,
  DefaultError,
  Options<ParseCandidateResumeData>
> => {
  const mutationOptions: UseMutationOptions<
    ParseCandidateResumeResponse,
    DefaultError,
    Options<ParseCandidateResumeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await parseCandidateResume({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJobAnalyticsQueryKey = (
  options: Options<GetJobAnalyticsData>,
) => createQueryKey('getJobAnalytics', options);

/**
 * Comprehensive analytics for a job
 */
export const getJobAnalyticsOptions = (options: Options<GetJobAnalyticsData>) =>
  queryOptions<
    GetJobAnalyticsResponse,
    DefaultError,
    GetJobAnalyticsResponse,
    ReturnType<typeof getJobAnalyticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalytics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsQueryKey(options),
  });

export const getJobAnalyticsBatchesQueryKey = (
  options: Options<GetJobAnalyticsBatchesData>,
) => createQueryKey('getJobAnalyticsBatches', options);

/**
 * Distinct batch values for the job filter dropdown
 */
export const getJobAnalyticsBatchesOptions = (
  options: Options<GetJobAnalyticsBatchesData>,
) =>
  queryOptions<
    GetJobAnalyticsBatchesResponse,
    DefaultError,
    GetJobAnalyticsBatchesResponse,
    ReturnType<typeof getJobAnalyticsBatchesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalyticsBatches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsBatchesQueryKey(options),
  });

export const getJobAnalyticsExcelQueryKey = (
  options: Options<GetJobAnalyticsExcelData>,
) => createQueryKey('getJobAnalyticsExcel', options);

/**
 * Download analytics as a multi-sheet Excel workbook
 */
export const getJobAnalyticsExcelOptions = (
  options: Options<GetJobAnalyticsExcelData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getJobAnalyticsExcelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobAnalyticsExcel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobAnalyticsExcelQueryKey(options),
  });

export const getConsumptionReportQueryKey = (
  options?: Options<GetConsumptionReportData>,
) => createQueryKey('getConsumptionReport', options);

/**
 * Download tenant consumption report
 */
export const getConsumptionReportOptions = (
  options?: Options<GetConsumptionReportData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getConsumptionReportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConsumptionReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getConsumptionReportQueryKey(options),
  });

export const getUsageAnalyticsQueryKey = (
  options?: Options<GetUsageAnalyticsData>,
) => createQueryKey('getUsageAnalytics', options);

/**
 * Get consumption analytics for the tenant
 */
export const getUsageAnalyticsOptions = (
  options?: Options<GetUsageAnalyticsData>,
) =>
  queryOptions<
    GetUsageAnalyticsResponse,
    DefaultError,
    GetUsageAnalyticsResponse,
    ReturnType<typeof getUsageAnalyticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsageAnalytics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUsageAnalyticsQueryKey(options),
  });

export const listEmailTemplatesQueryKey = (
  options: Options<ListEmailTemplatesData>,
) => createQueryKey('listEmailTemplates', options);

/**
 * The job's email templates, without bodies
 */
export const listEmailTemplatesOptions = (
  options: Options<ListEmailTemplatesData>,
) =>
  queryOptions<
    ListEmailTemplatesResult,
    DefaultError,
    ListEmailTemplatesResult,
    ReturnType<typeof listEmailTemplatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEmailTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEmailTemplatesQueryKey(options),
  });

export const getEmailTemplateQueryKey = (
  options: Options<GetEmailTemplateData>,
) => createQueryKey('getEmailTemplate', options);

/**
 * One email template with its subject and bodies
 */
export const getEmailTemplateOptions = (
  options: Options<GetEmailTemplateData>,
) =>
  queryOptions<
    GetEmailTemplateResponse,
    DefaultError,
    GetEmailTemplateResponse,
    ReturnType<typeof getEmailTemplateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEmailTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEmailTemplateQueryKey(options),
  });

export const getEmailTemplateVariablesQueryKey = (
  options: Options<GetEmailTemplateVariablesData>,
) => createQueryKey('getEmailTemplateVariables', options);

/**
 * The variables a trigger's template may use, with example values for this job
 */
export const getEmailTemplateVariablesOptions = (
  options: Options<GetEmailTemplateVariablesData>,
) =>
  queryOptions<
    GetEmailTemplateVariablesResponse,
    DefaultError,
    GetEmailTemplateVariablesResponse,
    ReturnType<typeof getEmailTemplateVariablesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEmailTemplateVariables({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEmailTemplateVariablesQueryKey(options),
  });

export const searchSentEmailsQueryKey = (
  options: Options<SearchSentEmailsData>,
) => createQueryKey('searchSentEmails', options);

/**
 * Emails sent for the job, a page of them plus counts over the same filters
 */
export const searchSentEmailsOptions = (
  options: Options<SearchSentEmailsData>,
) =>
  queryOptions<
    SearchSentEmailsResponse,
    DefaultError,
    SearchSentEmailsResponse,
    ReturnType<typeof searchSentEmailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchSentEmails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchSentEmailsQueryKey(options),
  });

export const searchSentEmailsInfiniteQueryKey = (
  options: Options<SearchSentEmailsData>,
): QueryKey<Options<SearchSentEmailsData>> =>
  createQueryKey('searchSentEmails', options, true);

/**
 * Emails sent for the job, a page of them plus counts over the same filters
 */
export const searchSentEmailsInfiniteOptions = (
  options: Options<SearchSentEmailsData>,
) =>
  infiniteQueryOptions<
    SearchSentEmailsResponse,
    DefaultError,
    InfiniteData<SearchSentEmailsResponse>,
    QueryKey<Options<SearchSentEmailsData>>,
    | number
    | Pick<
        QueryKey<Options<SearchSentEmailsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchSentEmailsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchSentEmails({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchSentEmailsInfiniteQueryKey(options),
    },
  );

/**
 * Save a template's subject, body or settings
 */
export const updateEmailTemplateMutation = (
  options?: Partial<Options<UpdateEmailTemplateData>>,
): UseMutationOptions<
  UpdateEmailTemplateResponse,
  DefaultError,
  Options<UpdateEmailTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateEmailTemplateResponse,
    DefaultError,
    Options<UpdateEmailTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateEmailTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send the saved template, filled with example values, to one address
 */
export const sendTestEmailMutation = (
  options?: Partial<Options<SendTestEmailData>>,
): UseMutationOptions<
  SendTestEmailResult,
  DefaultError,
  Options<SendTestEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    SendTestEmailResult,
    DefaultError,
    Options<SendTestEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendTestEmail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Ask for delivery statuses to be pulled now
 */
export const refreshSentEmailsMutation = (
  options?: Partial<Options<RefreshSentEmailsData>>,
): UseMutationOptions<
  RefreshSentEmailsResult,
  DefaultError,
  Options<RefreshSentEmailsData>
> => {
  const mutationOptions: UseMutationOptions<
    RefreshSentEmailsResult,
    DefaultError,
    Options<RefreshSentEmailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshSentEmails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const generateInkeepTokenQueryKey = (
  options?: Options<GenerateInkeepTokenData>,
) => createQueryKey('generateInkeepToken', options);

/**
 * Generate a short-lived JWT for Inkeep agents-api authentication
 *
 * Returns a 30-minute HS256 JWT signed with the platform secret key. The Inkeep agents-api verifies this token (via DJANGO_SECRET_KEY env var) to authenticate support-chat requests without a session cookie proxy.
 */
export const generateInkeepTokenOptions = (
  options?: Options<GenerateInkeepTokenData>,
) =>
  queryOptions<
    GenerateInkeepTokenResponse,
    DefaultError,
    GenerateInkeepTokenResponse,
    ReturnType<typeof generateInkeepTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateInkeepToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: generateInkeepTokenQueryKey(options),
  });

/**
 * Execute Task
 */
export const executeTaskTasksExecutePostMutation = (
  options?: Partial<Options<ExecuteTaskTasksExecutePostData>>,
): UseMutationOptions<
  ExecuteTaskTasksExecutePostResponse,
  ExecuteTaskTasksExecutePostError,
  Options<ExecuteTaskTasksExecutePostData>
> => {
  const mutationOptions: UseMutationOptions<
    ExecuteTaskTasksExecutePostResponse,
    ExecuteTaskTasksExecutePostError,
    Options<ExecuteTaskTasksExecutePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await executeTaskTasksExecutePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPartnerCredentialByKeyIdQueryKey = (
  options: Options<GetPartnerCredentialByKeyIdData>,
) => createQueryKey('getPartnerCredentialByKeyId', options);

/**
 * Read a partner API credential by key id
 *
 * Same as reading by credential id, addressed by the key's public half. After a leak the artifact in hand is the key itself, not the credential id that was printed once at creation.
 */
export const getPartnerCredentialByKeyIdOptions = (
  options: Options<GetPartnerCredentialByKeyIdData>,
) =>
  queryOptions<
    GetPartnerCredentialByKeyIdResponse,
    DefaultError,
    GetPartnerCredentialByKeyIdResponse,
    ReturnType<typeof getPartnerCredentialByKeyIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPartnerCredentialByKeyId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPartnerCredentialByKeyIdQueryKey(options),
  });

export const getPartnerCredentialQueryKey = (
  options: Options<GetPartnerCredentialData>,
) => createQueryKey('getPartnerCredential', options);

/**
 * Read a partner API credential
 *
 * Identity and lifecycle state for one credential. Never returns secret material — the API key exists only in the response that created it.
 */
export const getPartnerCredentialOptions = (
  options: Options<GetPartnerCredentialData>,
) =>
  queryOptions<
    GetPartnerCredentialResponse,
    DefaultError,
    GetPartnerCredentialResponse,
    ReturnType<typeof getPartnerCredentialQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPartnerCredential({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPartnerCredentialQueryKey(options),
  });

/**
 * Provision a partner API credential
 *
 * Creates the service account, role and membership if absent, then mints a key. Idempotent.
 */
export const createPartnerCredentialMutation = (
  options?: Partial<Options<CreatePartnerCredentialData>>,
): UseMutationOptions<
  CreatePartnerCredentialResult,
  DefaultError,
  Options<CreatePartnerCredentialData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePartnerCredentialResult,
    DefaultError,
    Options<CreatePartnerCredentialData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPartnerCredential({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke a partner API credential by key id
 *
 * The incident path: revoke straight from the leaked key's public half, without first looking up its credential id. Idempotent, like revoking by id.
 */
export const revokePartnerCredentialByKeyIdMutation = (
  options?: Partial<Options<RevokePartnerCredentialByKeyIdData>>,
): UseMutationOptions<
  RevokePartnerCredentialByKeyIdResponse,
  DefaultError,
  Options<RevokePartnerCredentialByKeyIdData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokePartnerCredentialByKeyIdResponse,
    DefaultError,
    Options<RevokePartnerCredentialByKeyIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokePartnerCredentialByKeyId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke a partner API credential
 *
 * Retires the key immediately; the next request presenting it gets 401. Idempotent — revoking an already-revoked credential succeeds and reports `revoked_now: false`. The service account and its membership are left in place, so a replacement key can be minted without re-provisioning them.
 */
export const revokePartnerCredentialMutation = (
  options?: Partial<Options<RevokePartnerCredentialData>>,
): UseMutationOptions<
  RevokePartnerCredentialResult,
  DefaultError,
  Options<RevokePartnerCredentialData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokePartnerCredentialResult,
    DefaultError,
    Options<RevokePartnerCredentialData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokePartnerCredential({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a partner credential's webhook by key id
 *
 * Change the webhook URL, signing secret or auth token in place, addressed by the key's public half. Partial: fields left out are untouched.
 */
export const updatePartnerCredentialWebhookByKeyIdMutation = (
  options?: Partial<Options<UpdatePartnerCredentialWebhookByKeyIdData>>,
): UseMutationOptions<
  UpdatePartnerCredentialWebhookByKeyIdResponse,
  DefaultError,
  Options<UpdatePartnerCredentialWebhookByKeyIdData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePartnerCredentialWebhookByKeyIdResponse,
    DefaultError,
    Options<UpdatePartnerCredentialWebhookByKeyIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePartnerCredentialWebhookByKeyId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a partner credential's webhook
 *
 * Change the webhook URL, signing secret or auth token in place, without revoking and re-minting the key. Partial: a field left out keeps its current value. A supplied URL is re-validated before it is stored.
 */
export const updatePartnerCredentialWebhookMutation = (
  options?: Partial<Options<UpdatePartnerCredentialWebhookData>>,
): UseMutationOptions<
  UpdatePartnerCredentialWebhookResponse,
  DefaultError,
  Options<UpdatePartnerCredentialWebhookData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePartnerCredentialWebhookResponse,
    DefaultError,
    Options<UpdatePartnerCredentialWebhookData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePartnerCredentialWebhook({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWorkflowAvailableEventsQueryKey = (
  options: Options<GetWorkflowAvailableEventsData>,
) => createQueryKey('getWorkflowAvailableEvents', options);

/**
 * Get Available Events
 */
export const getWorkflowAvailableEventsOptions = (
  options: Options<GetWorkflowAvailableEventsData>,
) =>
  queryOptions<
    GetWorkflowAvailableEventsResponse,
    DefaultError,
    GetWorkflowAvailableEventsResponse,
    ReturnType<typeof getWorkflowAvailableEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowAvailableEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowAvailableEventsQueryKey(options),
  });

export const getWorkflowAuditHistoryQueryKey = (
  options: Options<GetWorkflowAuditHistoryData>,
) => createQueryKey('getWorkflowAuditHistory', options);

/**
 * Get Audit History
 */
export const getWorkflowAuditHistoryOptions = (
  options: Options<GetWorkflowAuditHistoryData>,
) =>
  queryOptions<
    GetWorkflowAuditHistoryResponse,
    DefaultError,
    GetWorkflowAuditHistoryResponse,
    ReturnType<typeof getWorkflowAuditHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowAuditHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowAuditHistoryQueryKey(options),
  });

export const workflowRejectBelowPreviewQueryKey = (
  options: Options<WorkflowRejectBelowPreviewData>,
) => createQueryKey('workflowRejectBelowPreview', options);

/**
 * The unreviewed AI rejects rated below a threshold that Reject below would confirm
 */
export const workflowRejectBelowPreviewOptions = (
  options: Options<WorkflowRejectBelowPreviewData>,
) =>
  queryOptions<
    WorkflowRejectBelowPreviewResponse,
    DefaultError,
    WorkflowRejectBelowPreviewResponse,
    ReturnType<typeof workflowRejectBelowPreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await workflowRejectBelowPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: workflowRejectBelowPreviewQueryKey(options),
  });

/**
 * Get Bulk Available Events
 */
export const getWorkflowBulkAvailableEventsMutation = (
  options?: Partial<Options<GetWorkflowBulkAvailableEventsData>>,
): UseMutationOptions<
  GetWorkflowBulkAvailableEventsResponse,
  DefaultError,
  Options<GetWorkflowBulkAvailableEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    GetWorkflowBulkAvailableEventsResponse,
    DefaultError,
    Options<GetWorkflowBulkAvailableEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await getWorkflowBulkAvailableEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transition
 */
export const workflowTransitionMutation = (
  options?: Partial<Options<WorkflowTransitionData>>,
): UseMutationOptions<
  WorkflowTransitionResponse,
  DefaultError,
  Options<WorkflowTransitionData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowTransitionResponse,
    DefaultError,
    Options<WorkflowTransitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowTransition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Transition
 */
export const workflowBulkTransitionMutation = (
  options?: Partial<Options<WorkflowBulkTransitionData>>,
): UseMutationOptions<
  WorkflowBulkTransitionResponse,
  DefaultError,
  Options<WorkflowBulkTransitionData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkTransitionResponse,
    DefaultError,
    Options<WorkflowBulkTransitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkTransition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Submit Human Review
 */
export const workflowSubmitHumanReviewMutation = (
  options?: Partial<Options<WorkflowSubmitHumanReviewData>>,
): UseMutationOptions<
  WorkflowSubmitHumanReviewResponse,
  DefaultError,
  Options<WorkflowSubmitHumanReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowSubmitHumanReviewResponse,
    DefaultError,
    Options<WorkflowSubmitHumanReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowSubmitHumanReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confirm the AI's Reject for every unreviewed candidate rated below a threshold
 */
export const workflowBulkRejectBelowMutation = (
  options?: Partial<Options<WorkflowBulkRejectBelowData>>,
): UseMutationOptions<
  WorkflowBulkRejectBelowResponse,
  DefaultError,
  Options<WorkflowBulkRejectBelowData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkRejectBelowResponse,
    DefaultError,
    Options<WorkflowBulkRejectBelowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkRejectBelow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign Reviewer
 */
export const workflowAssignReviewerMutation = (
  options?: Partial<Options<WorkflowAssignReviewerData>>,
): UseMutationOptions<
  WorkflowAssignReviewerResponse,
  DefaultError,
  Options<WorkflowAssignReviewerData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowAssignReviewerResponse,
    DefaultError,
    Options<WorkflowAssignReviewerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowAssignReviewer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Assign Reviewer
 */
export const workflowBulkAssignReviewerMutation = (
  options?: Partial<Options<WorkflowBulkAssignReviewerData>>,
): UseMutationOptions<
  WorkflowBulkAssignReviewerResponse,
  DefaultError,
  Options<WorkflowBulkAssignReviewerData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkAssignReviewerResponse,
    DefaultError,
    Options<WorkflowBulkAssignReviewerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkAssignReviewer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Assign By Added By
 */
export const workflowBulkAssignByAddedByMutation = (
  options?: Partial<Options<WorkflowBulkAssignByAddedByData>>,
): UseMutationOptions<
  WorkflowBulkAssignByAddedByResponse,
  DefaultError,
  Options<WorkflowBulkAssignByAddedByData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkAssignByAddedByResponse,
    DefaultError,
    Options<WorkflowBulkAssignByAddedByData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkAssignByAddedBy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Send Reminder
 */
export const workflowBulkSendReminderMutation = (
  options?: Partial<Options<WorkflowBulkSendReminderData>>,
): UseMutationOptions<
  WorkflowBulkSendReminderResponse,
  DefaultError,
  Options<WorkflowBulkSendReminderData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkSendReminderResponse,
    DefaultError,
    Options<WorkflowBulkSendReminderData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkSendReminder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reminder Preview
 */
export const workflowReminderPreviewMutation = (
  options?: Partial<Options<WorkflowReminderPreviewData>>,
): UseMutationOptions<
  WorkflowReminderPreviewResponse,
  DefaultError,
  Options<WorkflowReminderPreviewData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowReminderPreviewResponse,
    DefaultError,
    Options<WorkflowReminderPreviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowReminderPreview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Change Deadline
 */
export const workflowBulkChangeDeadlineMutation = (
  options?: Partial<Options<WorkflowBulkChangeDeadlineData>>,
): UseMutationOptions<
  WorkflowBulkChangeDeadlineResponse,
  DefaultError,
  Options<WorkflowBulkChangeDeadlineData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkChangeDeadlineResponse,
    DefaultError,
    Options<WorkflowBulkChangeDeadlineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkChangeDeadline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Change Assessment Deadline
 */
export const workflowBulkChangeAssessmentDeadlineMutation = (
  options?: Partial<Options<WorkflowBulkChangeAssessmentDeadlineData>>,
): UseMutationOptions<
  WorkflowBulkChangeAssessmentDeadlineResponse,
  DefaultError,
  Options<WorkflowBulkChangeAssessmentDeadlineData>
> => {
  const mutationOptions: UseMutationOptions<
    WorkflowBulkChangeAssessmentDeadlineResponse,
    DefaultError,
    Options<WorkflowBulkChangeAssessmentDeadlineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await workflowBulkChangeAssessmentDeadline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCodingAssessmentPreviewQueryKey = (
  options: Options<GetCodingAssessmentPreviewData>,
) => createQueryKey('getCodingAssessmentPreview', options);

/**
 * Get Assessment Preview
 */
export const getCodingAssessmentPreviewOptions = (
  options: Options<GetCodingAssessmentPreviewData>,
) =>
  queryOptions<
    GetCodingAssessmentPreviewResponse,
    DefaultError,
    GetCodingAssessmentPreviewResponse,
    ReturnType<typeof getCodingAssessmentPreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCodingAssessmentPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCodingAssessmentPreviewQueryKey(options),
  });

/**
 * Start Assessment
 */
export const startCodingAssessmentMutation = (
  options?: Partial<Options<StartCodingAssessmentData>>,
): UseMutationOptions<
  StartCodingAssessmentResponse,
  DefaultError,
  Options<StartCodingAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCodingAssessmentResponse,
    DefaultError,
    Options<StartCodingAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCodingAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start the candidate's clock at the moment the editor appears, not at /start
 */
export const markCodingAssessmentEditorLoadedMutation = (
  options?: Partial<Options<MarkCodingAssessmentEditorLoadedData>>,
): UseMutationOptions<
  MarkCodingAssessmentEditorLoadedResponse,
  DefaultError,
  Options<MarkCodingAssessmentEditorLoadedData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkCodingAssessmentEditorLoadedResponse,
    DefaultError,
    Options<MarkCodingAssessmentEditorLoadedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markCodingAssessmentEditorLoaded({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sync Draft
 */
export const syncCodingAssessmentDraftMutation = (
  options?: Partial<Options<SyncCodingAssessmentDraftData>>,
): UseMutationOptions<
  SyncCodingAssessmentDraftResponse,
  DefaultError,
  Options<SyncCodingAssessmentDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    SyncCodingAssessmentDraftResponse,
    DefaultError,
    Options<SyncCodingAssessmentDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await syncCodingAssessmentDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Run Code
 */
export const runCodingAssessmentCodeMutation = (
  options?: Partial<Options<RunCodingAssessmentCodeData>>,
): UseMutationOptions<
  RunCodingAssessmentCodeResponse,
  DefaultError,
  Options<RunCodingAssessmentCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    RunCodingAssessmentCodeResponse,
    DefaultError,
    Options<RunCodingAssessmentCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await runCodingAssessmentCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Submit Code
 */
export const submitCodingAssessmentCodeMutation = (
  options?: Partial<Options<SubmitCodingAssessmentCodeData>>,
): UseMutationOptions<
  SubmitCodingAssessmentCodeResponse,
  DefaultError,
  Options<SubmitCodingAssessmentCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitCodingAssessmentCodeResponse,
    DefaultError,
    Options<SubmitCodingAssessmentCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitCodingAssessmentCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCodingAssessmentExecutionStatusQueryKey = (
  options: Options<GetCodingAssessmentExecutionStatusData>,
) => createQueryKey('getCodingAssessmentExecutionStatus', options);

/**
 * Get Execution Status
 */
export const getCodingAssessmentExecutionStatusOptions = (
  options: Options<GetCodingAssessmentExecutionStatusData>,
) =>
  queryOptions<
    GetCodingAssessmentExecutionStatusResponse,
    DefaultError,
    GetCodingAssessmentExecutionStatusResponse,
    ReturnType<typeof getCodingAssessmentExecutionStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCodingAssessmentExecutionStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCodingAssessmentExecutionStatusQueryKey(options),
  });

export const listCodingAssessmentSubmissionsQueryKey = (
  options: Options<ListCodingAssessmentSubmissionsData>,
) => createQueryKey('listCodingAssessmentSubmissions', options);

/**
 * List Submissions
 */
export const listCodingAssessmentSubmissionsOptions = (
  options: Options<ListCodingAssessmentSubmissionsData>,
) =>
  queryOptions<
    ListCodingAssessmentSubmissionsResponse,
    DefaultError,
    ListCodingAssessmentSubmissionsResponse,
    ReturnType<typeof listCodingAssessmentSubmissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCodingAssessmentSubmissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCodingAssessmentSubmissionsQueryKey(options),
  });

export const getCodingAssessmentProblemAssetQueryKey = (
  options: Options<GetCodingAssessmentProblemAssetData>,
) => createQueryKey('getCodingAssessmentProblemAsset', options);

/**
 * Serve a diagram the problem statement references, to its candidate or a recruiter on the job
 */
export const getCodingAssessmentProblemAssetOptions = (
  options: Options<GetCodingAssessmentProblemAssetData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getCodingAssessmentProblemAssetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCodingAssessmentProblemAsset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCodingAssessmentProblemAssetQueryKey(options),
  });

/**
 * Complete Assessment
 */
export const completeCodingAssessmentMutation = (
  options?: Partial<Options<CompleteCodingAssessmentData>>,
): UseMutationOptions<
  CompleteCodingAssessmentResponse,
  DefaultError,
  Options<CompleteCodingAssessmentData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteCodingAssessmentResponse,
    DefaultError,
    Options<CompleteCodingAssessmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeCodingAssessment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Batch-ingest candidate-emitted proctoring events (behavioral signals + real-time violations)
 */
export const recordCodingAssessmentEventsMutation = (
  options?: Partial<Options<RecordCodingAssessmentEventsData>>,
): UseMutationOptions<
  RecordCodingAssessmentEventsResponse,
  DefaultError,
  Options<RecordCodingAssessmentEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordCodingAssessmentEventsResponse,
    DefaultError,
    Options<RecordCodingAssessmentEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordCodingAssessmentEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Recording Session
 */
export const createCodingAssessmentRecordingSessionMutation = (
  options?: Partial<Options<CreateCodingAssessmentRecordingSessionData>>,
): UseMutationOptions<
  CreateCodingAssessmentRecordingSessionResponse,
  DefaultError,
  Options<CreateCodingAssessmentRecordingSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCodingAssessmentRecordingSessionResponse,
    DefaultError,
    Options<CreateCodingAssessmentRecordingSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCodingAssessmentRecordingSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAssessmentApplicationsQueryKey = (
  options: Options<GetAssessmentApplicationsData>,
) => createQueryKey('getAssessmentApplications', options);

/**
 * List assessment-round applications for a job, or one application in full when application_id is given
 */
export const getAssessmentApplicationsOptions = (
  options: Options<GetAssessmentApplicationsData>,
) =>
  queryOptions<
    GetAssessmentApplicationsResponse,
    DefaultError,
    GetAssessmentApplicationsResponse,
    ReturnType<typeof getAssessmentApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentApplications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentApplicationsQueryKey(options),
  });

export const getAssessmentApplicationsInfiniteQueryKey = (
  options: Options<GetAssessmentApplicationsData>,
): QueryKey<Options<GetAssessmentApplicationsData>> =>
  createQueryKey('getAssessmentApplications', options, true);

/**
 * List assessment-round applications for a job, or one application in full when application_id is given
 */
export const getAssessmentApplicationsInfiniteOptions = (
  options: Options<GetAssessmentApplicationsData>,
) =>
  infiniteQueryOptions<
    GetAssessmentApplicationsResponse,
    DefaultError,
    InfiniteData<GetAssessmentApplicationsResponse>,
    QueryKey<Options<GetAssessmentApplicationsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetAssessmentApplicationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetAssessmentApplicationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAssessmentApplications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getAssessmentApplicationsInfiniteQueryKey(options),
    },
  );

export const getAssessmentAttemptQueryKey = (
  options: Options<GetAssessmentAttemptData>,
) => createQueryKey('getAssessmentAttempt', options);

/**
 * One coding assessment attempt in full, keyed by the attempt id the review page is addressed by
 */
export const getAssessmentAttemptOptions = (
  options: Options<GetAssessmentAttemptData>,
) =>
  queryOptions<
    GetAssessmentAttemptResponse,
    DefaultError,
    GetAssessmentAttemptResponse,
    ReturnType<typeof getAssessmentAttemptQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentAttempt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentAttemptQueryKey(options),
  });

export const getAssessmentAttemptRecordingUrlQueryKey = (
  options: Options<GetAssessmentAttemptRecordingUrlData>,
) => createQueryKey('getAssessmentAttemptRecordingUrl', options);

/**
 * Signed recording for one attempt; separate from the detail read because the storage lookup is slow
 */
export const getAssessmentAttemptRecordingUrlOptions = (
  options: Options<GetAssessmentAttemptRecordingUrlData>,
) =>
  queryOptions<
    GetAssessmentAttemptRecordingUrlResponse,
    DefaultError,
    GetAssessmentAttemptRecordingUrlResponse,
    ReturnType<typeof getAssessmentAttemptRecordingUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentAttemptRecordingUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentAttemptRecordingUrlQueryKey(options),
  });

export const getAssessmentRecordingUrlQueryKey = (
  options: Options<GetAssessmentRecordingUrlData>,
) => createQueryKey('getAssessmentRecordingUrl', options);

/**
 * Signed recording for one application (single camera url or multi-track manifest); separate from detail because the storage lookup is slow
 */
export const getAssessmentRecordingUrlOptions = (
  options: Options<GetAssessmentRecordingUrlData>,
) =>
  queryOptions<
    GetAssessmentRecordingUrlResponse,
    DefaultError,
    GetAssessmentRecordingUrlResponse,
    ReturnType<typeof getAssessmentRecordingUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentRecordingUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentRecordingUrlQueryKey(options),
  });

export const getAssessmentConfigQueryKey = (
  options: Options<GetAssessmentConfigData>,
) => createQueryKey('getAssessmentConfig', options);

/**
 * Get the recruiter-configured assessment template for a job, if any
 */
export const getAssessmentConfigOptions = (
  options: Options<GetAssessmentConfigData>,
) =>
  queryOptions<
    GetAssessmentConfigResult,
    DefaultError,
    GetAssessmentConfigResult,
    ReturnType<typeof getAssessmentConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssessmentConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssessmentConfigQueryKey(options),
  });

/**
 * Save the recruiter-configured assessment template for a job
 */
export const saveAssessmentConfigMutation = (
  options?: Partial<Options<SaveAssessmentConfigData>>,
): UseMutationOptions<
  SaveAssessmentConfigResponse,
  DefaultError,
  Options<SaveAssessmentConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveAssessmentConfigResponse,
    DefaultError,
    Options<SaveAssessmentConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAssessmentConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const suggestAssessmentDesignQueryKey = (
  options: Options<SuggestAssessmentDesignData>,
) => createQueryKey('suggestAssessmentDesign', options);

/**
 * Suggest a first assessment design from the job description, unsaved
 */
export const suggestAssessmentDesignOptions = (
  options: Options<SuggestAssessmentDesignData>,
) =>
  queryOptions<
    SuggestAssessmentDesignResult,
    DefaultError,
    SuggestAssessmentDesignResult,
    ReturnType<typeof suggestAssessmentDesignQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await suggestAssessmentDesign({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: suggestAssessmentDesignQueryKey(options),
  });

export const getProblemTopicsQueryKey = (
  options: Options<GetProblemTopicsData>,
) => createQueryKey('getProblemTopics', options);

/**
 * List the topics a problem slot can draw from at one difficulty, with pool sizes
 */
export const getProblemTopicsOptions = (
  options: Options<GetProblemTopicsData>,
) =>
  queryOptions<
    GetProblemTopicsResponse,
    DefaultError,
    GetProblemTopicsResponse,
    ReturnType<typeof getProblemTopicsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProblemTopics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProblemTopicsQueryKey(options),
  });

/**
 * Run the candidate draw against an unsaved design and return the problems it dealt
 */
export const previewSampleProblemsMutation = (
  options?: Partial<Options<PreviewSampleProblemsData>>,
): UseMutationOptions<
  PreviewSampleProblemsResult,
  DefaultError,
  Options<PreviewSampleProblemsData>
> => {
  const mutationOptions: UseMutationOptions<
    PreviewSampleProblemsResult,
    DefaultError,
    Options<PreviewSampleProblemsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await previewSampleProblems({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProblemBankAssetQueryKey = (
  options: Options<GetProblemBankAssetData>,
) => createQueryKey('getProblemBankAsset', options);

/**
 * Serve a diagram in a previewed problem statement, to a recruiter on the job
 */
export const getProblemBankAssetOptions = (
  options: Options<GetProblemBankAssetData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getProblemBankAssetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProblemBankAsset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProblemBankAssetQueryKey(options),
  });

/**
 * Set the coding assessment's live proctoring toggles for a job
 */
export const updateAssessmentLiveProctoringMutation = (
  options?: Partial<Options<UpdateAssessmentLiveProctoringData>>,
): UseMutationOptions<
  UpdateAssessmentLiveProctoringResponse,
  DefaultError,
  Options<UpdateAssessmentLiveProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssessmentLiveProctoringResponse,
    DefaultError,
    Options<UpdateAssessmentLiveProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssessmentLiveProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Replace the pre-assessment instructions a candidate sees before starting
 */
export const updateAssessmentInstructionsMutation = (
  options?: Partial<Options<UpdateAssessmentInstructionsData>>,
): UseMutationOptions<
  UpdateAssessmentInstructionsResponse,
  DefaultError,
  Options<UpdateAssessmentInstructionsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssessmentInstructionsResponse,
    DefaultError,
    Options<UpdateAssessmentInstructionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssessmentInstructions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Turn post-assessment AI proctoring on or off for a job
 */
export const updateAssessmentAiProctoringMutation = (
  options?: Partial<Options<UpdateAssessmentAiProctoringData>>,
): UseMutationOptions<
  UpdateAssessmentAiProctoringResponse,
  DefaultError,
  Options<UpdateAssessmentAiProctoringData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssessmentAiProctoringResponse,
    DefaultError,
    Options<UpdateAssessmentAiProctoringData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssessmentAiProctoring({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save what the recruiter wants this round to reflect
 */
export const saveAssessmentRequirementsMutation = (
  options?: Partial<Options<SaveAssessmentRequirementsData>>,
): UseMutationOptions<
  SaveAssessmentRequirementsResponse,
  DefaultError,
  Options<SaveAssessmentRequirementsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveAssessmentRequirementsResponse,
    DefaultError,
    Options<SaveAssessmentRequirementsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAssessmentRequirements({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSharedAssessmentResultQueryKey = (
  options: Options<GetSharedAssessmentResultData>,
) => createQueryKey('getSharedAssessmentResult', options);

/**
 * Read one assessment result with a share token instead of a session
 *
 * The assessment counterpart of the interview share link. The assessment is identified by the token, not by a parameter: a tampered or expired token is rejected before any row is read.
 */
export const getSharedAssessmentResultOptions = (
  options: Options<GetSharedAssessmentResultData>,
) =>
  queryOptions<
    GetSharedAssessmentResultResponse,
    DefaultError,
    GetSharedAssessmentResultResponse,
    ReturnType<typeof getSharedAssessmentResultQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSharedAssessmentResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSharedAssessmentResultQueryKey(options),
  });

export const getSharedAssessmentRecordingUrlQueryKey = (
  options: Options<GetSharedAssessmentRecordingUrlData>,
) => createQueryKey('getSharedAssessmentRecordingUrl', options);

/**
 * Signed recording for a share-token holder; separate from the result for the same slow-lookup reason
 */
export const getSharedAssessmentRecordingUrlOptions = (
  options: Options<GetSharedAssessmentRecordingUrlData>,
) =>
  queryOptions<
    GetSharedAssessmentRecordingUrlResponse,
    DefaultError,
    GetSharedAssessmentRecordingUrlResponse,
    ReturnType<typeof getSharedAssessmentRecordingUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSharedAssessmentRecordingUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSharedAssessmentRecordingUrlQueryKey(options),
  });

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey('getCurrentUser', options);

/**
 * Get the authenticated caller's identity
 *
 * Returns the authenticated user's {id, name, email} resolved from the request principal (no DB read). Replaces the legacy `/api/users/?search=<email>` self-lookup.
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) =>
  queryOptions<
    GetCurrentUserResponse,
    DefaultError,
    GetCurrentUserResponse,
    ReturnType<typeof getCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserQueryKey(options),
  });

/**
 * Update the authenticated caller's name
 *
 * Sets the caller's own first and last name. The target is always the request principal, so the body carries no user id. Replaces the pair: omitting `last_name` clears it.
 */
export const updateCurrentUserMutation = (
  options?: Partial<Options<UpdateCurrentUserData>>,
): UseMutationOptions<
  UpdateCurrentUserResponse,
  DefaultError,
  Options<UpdateCurrentUserData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCurrentUserResponse,
    DefaultError,
    Options<UpdateCurrentUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCurrentUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Record the caller's acceptance of the Terms / Privacy Policy
 *
 * Stamps the authenticated caller's consent to the given terms version. The target is always the request principal, so the body carries no user id. Idempotent per version.
 */
export const acceptTermsMutation = (
  options?: Partial<Options<AcceptTermsData>>,
): UseMutationOptions<
  AcceptTermsResponse,
  DefaultError,
  Options<AcceptTermsData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptTermsResponse,
    DefaultError,
    Options<AcceptTermsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptTerms({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const v2HealthHealthGetQueryKey = (
  options?: Options<V2HealthHealthGetData>,
) => createQueryKey('v2HealthHealthGet', options);

/**
 * V2 Health
 */
export const v2HealthHealthGetOptions = (
  options?: Options<V2HealthHealthGetData>,
) =>
  queryOptions<
    V2HealthHealthGetResponse,
    DefaultError,
    V2HealthHealthGetResponse,
    ReturnType<typeof v2HealthHealthGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await v2HealthHealthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: v2HealthHealthGetQueryKey(options),
  });
